{
  "account.account": "Профиль и безопасность",
  "account.accountDeleted": "Ваша учетная запись успешно удалена.",
  "account.accountDescription": "Имя, пароль, удаление аккаунта",
  "account.accountSection": "Аккаунт",
  "account.changeEmail": "Изменить электронную почту",
  "account.changePassword": "Изменить пароль",
  "account.currentPassword": "Текущий пароль",
  "account.dangerZone": "Опасная зона",
  "account.deleteAccount": "Удалить свой аккаунт",
  "account.deleteAccountConfirmation": "Вы уверены, что хотите удалить свою учетную запись? Это действие необратимо.",
  "account.deleteAccountDescription": "Это действие удалит вашу учетную запись и всю вашу информацию. Пути назад нет.",
  "account.emailChange": "Изменить адрес электронной почты",
  "account.emailChangeConfirmation": "Подтверждение изменения электронной почты",
  "account.emailChangeFailure": "Ссылка для изменения электронной почты недействительна или истекла.",
  "account.emailChangeIntro": "Введите новый адрес электронной почты и текущий пароль. Мы отправим ссылку на новый адрес: адрес изменится только после того, как вы её откроете.",
  "account.emailChangeNeedsPassword": "Чтобы изменить адрес электронной почты, сначала задайте пароль. Мы отправим вам для этого письмо со ссылкой. Вы останетесь в аккаунте.",
  "account.emailChangeSetPasswordFirst": "Чтобы изменить адрес электронной почты, сначала задайте пароль.",
  "account.emailChangeSuccess": "Ваш адрес электронной почты успешно изменен на {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Ваш адрес электронной почты успешно изменён.",
  "account.emailChangeVerificationSent": "Письмо с подтверждением отправлено на ваш новый адрес электронной почты. Проверьте входящие сообщения и нажмите на ссылку для подтверждения изменения.",
  "account.manageAccount": "Управлять аккаунтом",
  "account.newEmailAddress": "Новый адрес электронной почты",
  "account.newPassword": "Новый пароль",
  "account.newPasswordAgain": "Новый пароль еще раз",
  "account.noPasswordExplanation": "У вашего аккаунта пока нет пароля SmartMixin, потому что вы входите через Google, Apple или Facebook. Мы отправим вам письмо со ссылкой, чтобы задать пароль. Вы останетесь в аккаунте.",
  "account.oldPassword": "Старый пароль",
  "account.passwordChange": "Изменение пароля",
  "account.passwordChangeDescription": "Обеспечьте безопасность аккаунта",
  "account.passwordUpdated": "Пароль успешно обновлен.",
  "account.profile": "Профиль",
  "account.profileUpdated": "Профиль успешно обновлен.",
  "account.reauthAccountMismatchApple": "Этот Аккаунт Apple не связан со SmartMixin. Попробуйте ещё раз с Аккаунтом Apple, через который вы входите.",
  "account.reauthAccountMismatchGoogle": "Этот аккаунт Google не связан со SmartMixin. Попробуйте ещё раз и выберите аккаунт Google, через который вы входите.",
  "account.reauthAccountMismatchGoogleNamed": "Этот аккаунт Google не связан со SmartMixin. Попробуйте ещё раз и выберите {email}.",
  "account.reauthConfirmBody": "Чтобы изменить адрес электронной почты, подтвердите вход аккаунтом, через который вы входите.",
  "account.reauthConfirmed": "Подтверждено через {provider}",
  "account.reauthConfirmTitle": "Подтвердите, что это вы",
  "account.reauthExpired": "Срок подтверждения истёк. Подтвердите ещё раз, чтобы продолжить.",
  "account.reauthFailed": "Не удалось подтвердить, что это вы. Попробуйте ещё раз.",
  "account.reauthPopupBlocked": "Браузер заблокировал окно Apple. Нажмите кнопку ещё раз.",
  "account.reauthProviderUnavailable": "{provider} сейчас не отвечает. Попробуйте ещё раз через несколько минут.",
  "account.reauthSetPasswordInstead": "Задать пароль вместо этого",
  "account.reauthThrottled": "Вы несколько раз за короткое время пытались подтвердить вход. Повторите попытку позже.",
  "account.sendSetPasswordLink": "Отправить ссылку",
  "account.sendSetPasswordLinkLong": "Отправить ссылку, чтобы задать пароль",
  "account.setPassword": "Задать пароль",
  "account.setPasswordDescription": "У вашего аккаунта пока нет пароля",
  "account.setPasswordFirst": "Сначала задайте пароль",
  "account.setPasswordLinkError": "Не удалось отправить ссылку. Проверьте подключение и попробуйте ещё раз.",
  "account.setPasswordLinkRateLimited": "Вы запросили несколько ссылок за короткое время. Найдите последнюю во входящих или в папке «Спам» либо повторите попытку позже.",
  "account.setPasswordLinkResend": "Отправить ещё раз",
  "account.setPasswordLinkRetry": "Повторить",
  "account.setPasswordLinkSent": "Мы отправили ссылку на {email}. Откройте её, выберите пароль и вернитесь сюда.",
  "account.signedInAs": "Вы вошли как",
  "account.updateYourProfile": "Обновите профиль",
  "account.updateYourProfileDescription": "Имя и настройки отображения",
  "addons.accountOnHold": "Соединение вашей учётной записи истекло. Подключитесь повторно, чтобы возобновить обновление данных.",
  "addons.accountOnHoldTitle": "Аккаунт приостановлен",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Создайте и получите свой ключ API по этой ссылке.",
  "addons.ambientWeatherDescription": "Метеостанции Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API-ключ",
  "addons.applicationKey": "Ключ приложения",
  "addons.availableServices": "Доступные",
  "addons.cannotDisconnectLastAccount": "Невозможно отключить единственный способ входа. Сначала добавьте другой способ входа.",
  "addons.connect": "Подключить",
  "addons.connected": "Подключено",
  "addons.connectedAccounts": "Привязанные аккаунты",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Загрузка привязанных аккаунтов…",
  "addons.connectedServices": "Подключено",
  "addons.connectedSince": "Подключено с {date}",
  "addons.connectionSection": "Подключение",
  "addons.connectionSuccess": "Аккаунт {provider} успешно подключен",
  "addons.davisApiSecret": "Секрет API",
  "addons.davisApiV2Key": "API-ключ V2",
  "addons.davisDescription": "Метеостанции Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Получите ключи API V2 по этой ссылке.",
  "addons.disconnect": "Отключить",
  "addons.disconnectConfirmation": "Вы уверены, что хотите отключить аккаунт {provider}?",
  "addons.disconnectEnergyConfirmation": "SmartMixin прекратит синхронизацию с Netatmo Energy и удалит ваши дома из SmartMixin. Ваш аккаунт Netatmo и устройства при этом не затрагиваются.",
  "addons.disconnectEnergyDescription": "Останавливает синхронизацию и удаляет ваши дома из SmartMixin.",
  "addons.disconnectionSuccess": "Аккаунт {provider} успешно отключен",
  "addons.disconnectProviderDescription": "Останавливает синхронизацию и удаляет станции этого сервиса вместе с их историей.",
  "addons.disconnectServiceConfirmation": "SmartMixin прекратит синхронизацию с {provider} и удалит станции этого сервиса вместе со всей их историей. Сам ваш аккаунт {provider} при этом не затрагивается.",
  "addons.disconnectServiceTitle": "Отключить {provider}?",
  "addons.ecowittCreateAndRetrieveKeys": "Создайте и получите ключ API и ключ приложения по этой ссылке.",
  "addons.ecowittDescription": "Ecowitt предлагает профессиональные метеостанции с Wi-Fi, беспроводные внутренние и уличные термометры, мониторы влажности, высокоточные датчики дождя, мониторы качества воздуха и многое другое.",
  "addons.helpLink": "Как подключить {provider}",
  "addons.integrationsSection": "Интеграции",
  "addons.myAcuriteAccountOnHold": "Ваш аккаунт приостановлен. Пожалуйста, введите свой пароль, чтобы повторно подключить свою учетную запись",
  "addons.myAcuriteDescription": "AcuRite — бренд метеостанций №1 в Северной Америке. Являясь лидером в области технологий измерения времени, температуры и погоды, AcuRite предоставляет вам подробную информацию о вашей внутренней и внешней среде, чтобы вы могли с уверенностью планировать свой день.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Используйте термостат Netatmo, чтобы изменить температуру в вашем доме, не вставая с кровати или находясь на другом конце света.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Ваша личная метеостанция дома",
  "addons.notConnected": "Не подключено",
  "addons.or": "или",
  "addons.providerAccountDisconnected": "Соединение с вашей метеослужбой истекло. Подключитесь повторно, чтобы возобновить обновление данных.",
  "addons.reconnect": "Восстановить соединение",
  "addons.socialConnectionsIntro": "Свяжите свои социальные аккаунты для быстрого входа. Вы можете подключить или отключить аккаунты в любое время.",
  "addons.weatherflowAccessToken": "Токен доступа",
  "addons.weatherflowCreateToken": "Создайте и получите свой токен по этой ссылке",
  "addons.weatherflowTempestDescription": "Погодная система Tempest со встроенным ветромером и дождемером",
  "addons.weatherServices": "Метеорологические сервисы",
  "addons.weatherServicesConnected": "{count, plural, =0 {Нет подключенных сервисов} one {# сервис подключен} few {# сервиса подключено} many {# сервисов подключено} other {# сервисов подключено}}",
  "addons.weatherServicesDescription": "Подключите Netatmo, Davis, Weatherflow и другие",
  "addons.wundergroundApiKey": "API-ключ",
  "addons.wundergroundDescription": "Weather Underground — это глобальное сообщество людей, объединяющее данные датчиков окружающей среды, таких как метеостанции и мониторы качества воздуха, чтобы мы могли предоставлять обширные гиперлокальные данные, необходимые для реализации ваших увлечений.",
  "addons.wundergroundRemoveStationDescription": "Станция будет удалена из вашей учётной записи SmartMixin. Если её не добавила и другая учётная запись SmartMixin, станция и записанная для неё SmartMixin история будут удалены. В Weather Underground ничего не изменится.",
  "addons.wundergroundRemoveStationTitle": "Удалить {station}?",
  "addons.wundergroundRetrieveApiKey": "Получите свой ключ API по этой ссылке",
  "addons.wundergroundStationId": "Идентификатор станции",
  "airQuality.adviceActivityGood": "Идеальный день для активности на улице",
  "airQuality.adviceActivityHazardous": "Избегайте любой физической активности на улице",
  "airQuality.adviceActivityLabel": "Физическая активность",
  "airQuality.adviceActivityModerate": "Хороший день для активности на улице",
  "airQuality.adviceActivitySensitive": "Подумайте о более коротких и менее интенсивных занятиях на улице",
  "airQuality.adviceActivityUnhealthy": "Сократите долгие или интенсивные занятия и чаще делайте перерывы",
  "airQuality.adviceActivityVeryUnhealthy": "Избегайте долгих или интенсивных занятий; по возможности перенесите их в помещение",
  "airQuality.adviceGroupsGood": "Особые меры предосторожности не нужны",
  "airQuality.adviceGroupsHazardous": "Оставайтесь в помещении и снизьте активность",
  "airQuality.adviceGroupsLabel": "Чувствительные группы",
  "airQuality.adviceGroupsModerate": "Особо чувствительным людям: более короткие и менее интенсивные занятия",
  "airQuality.adviceGroupsSensitive": "Сделайте занятия на улице короче и менее интенсивными, чаще отдыхайте",
  "airQuality.adviceGroupsUnhealthy": "Избегайте долгих или интенсивных занятий на улице; по возможности перенесите их в помещение",
  "airQuality.adviceGroupsVeryUnhealthy": "Избегайте любой физической активности на улице; отложите её или перенесите в помещение",
  "airQuality.adviceTimingLabel": "Когда выходить",
  "airQuality.adviceTimingMorning": "Лучше утром — тогда озона меньше",
  "airQuality.airQuality": "Качество воздуха",
  "airQuality.airQualityIndex": "Индекс качества воздуха",
  "airQuality.aqiForecast": "Прогноз качества воздуха",
  "airQuality.co2Fresh": "Свежий",
  "airQuality.co2GettingStale": "Слегка душно",
  "airQuality.co2Stale": "Душно",
  "airQuality.dailyForecast": "Ежедневный прогноз",
  "airQuality.dominantPollutant": "Основной загрязнитель",
  "airQuality.expectedPeak": "Ожидаемый пик",
  "airQuality.expectedPeakAt": "Ожидаемый пик {value} · {band} · {time}",
  "airQuality.good": "Хороший",
  "airQuality.goodDescription": "Качество воздуха считается удовлетворительным, а загрязнение воздуха представляет небольшой риск или вообще не представляет никакого риска.",
  "airQuality.hazardous": "Опасный",
  "airQuality.hazardousDescription": "Предупреждение о здоровье: любой может столкнуться с более серьезными последствиями для здоровья",
  "airQuality.indoorAirQuality": "Качество воздуха в помещении",
  "airQuality.moderate": "Умеренный",
  "airQuality.moderateDescription": "Качество воздуха приемлемое; однако некоторые загрязняющие вещества могут представлять умеренную угрозу для здоровья очень небольшого числа людей, которые необычайно чувствительны к загрязнению воздуха.",
  "airQuality.noForecastForLocation": "Прогноз качества воздуха для этого места недоступен.",
  "airQuality.now": "Сейчас",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Загрязнители",
  "airQuality.recommendations": "Рекомендации",
  "airQuality.sensitiveUnhealthy": "Нездоровый для чувствительных групп",
  "airQuality.sensitiveUnhealthyDescription": "Члены чувствительных групп могут испытывать последствия для здоровья. Широкая общественность вряд ли пострадает.",
  "airQuality.subIndex": "Субиндекс AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Как читать индекс",
  "airQuality.unhealthy": "Нездоровый",
  "airQuality.unhealthyDescription": "Каждый может начать испытывать последствия для здоровья; члены чувствительных групп могут испытывать более серьезные последствия для здоровья",
  "airQuality.veryUnhealthy": "Очень нездоровый",
  "airQuality.veryUnhealthyDescription": "Предупреждения о чрезвычайных ситуациях. Скорее всего, пострадает все население.",
  "alerts.addAlert": "Добавить оповещение",
  "alerts.addCondition": "Добавить условие",
  "alerts.alertAdded": "Оповещение успешно добавлено",
  "alerts.alertAuthorizationNotice": "Оповещения работают только в том случае, если вы разрешаете SmartMixin отображать уведомления.",
  "alerts.alertDeleted": "Оповещение успешно удалено",
  "alerts.alertName": "Название оповещения",
  "alerts.alertWhen": "Я хочу получать оповещения, когда:",
  "alerts.aqiGreaterThan": "AQI больше, чем",
  "alerts.aqiGreaterThanThreshold": "AQI превышает порог {value}{unit}",
  "alerts.aqiLessThan": "AQI менее",
  "alerts.aqiLessThanThreshold": "AQI ниже порога {value}{unit}",
  "alerts.atLeastOneCondition": "Вам нужно добавить хотя бы одно условие",
  "alerts.co2GreaterThan": "CO2 больше, чем",
  "alerts.co2GreaterThanThreshold": "Уровень CO2 превышает пороговое значение {value}{unit}",
  "alerts.co2LessThan": "CO2 менее",
  "alerts.co2LessThanThreshold": "CO2 ниже порогового значения {value}{unit}",
  "alerts.conditions": "Условия",
  "alerts.conditionsDroppedOnStationChange": "Не поддерживается этой станцией, удалено: {conditions}",
  "alerts.createAlert": "Создать оповещение",
  "alerts.dailyPrecipitationGreaterThan": "Суточные осадки больше",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Суточные осадки превышают порог {value}{unit}",
  "alerts.deleteAlert": "Удалить оповещение",
  "alerts.deviceOnlyAlertNotice": "Ваши оповещения сохраняются только на этом устройстве. Войдите, чтобы привязать их к своей учётной записи.",
  "alerts.editAlert": "Изменить оповещение",
  "alerts.editCondition": "Изменить условие",
  "alerts.gustSpeedGreaterThan": "Скорость порыва более",
  "alerts.gustSpeedGreaterThanThreshold": "Скорость порыва превышает порог {value}{unit}",
  "alerts.gustSpeedLessThan": "Скорость порыва менее",
  "alerts.gustSpeedLessThanThreshold": "Скорость порыва ниже порога {value}{unit}",
  "alerts.heatIndexGreaterThan": "Индекс тепла более",
  "alerts.heatIndexGreaterThanThreshold": "Индекс тепла выше порогового значения {value}{unit}",
  "alerts.heatIndexLessThan": "Индекс тепла менее",
  "alerts.heatIndexLessThanThreshold": "Индекс тепла ниже порогового значения {value}{unit}",
  "alerts.humidexGreaterThan": "Гумидекс более",
  "alerts.humidexGreaterThanThreshold": "Гумидекс выше порогового значения {value}{unit}",
  "alerts.humidexLessThan": "Гумидекс менее",
  "alerts.humidexLessThanThreshold": "Гумидекс ниже порогового значения {value}{unit}",
  "alerts.humidityGreaterThan": "Влажность выше",
  "alerts.humidityGreaterThanThreshold": "Влажность выше порога {value}{unit}",
  "alerts.humidityLessThan": "Влажность менее",
  "alerts.humidityLessThanThreshold": "Влажность ниже порога {value}{unit}",
  "alerts.inProgress": "Продолжается",
  "alerts.leafWetnessGreaterThan": "Влажность листьев выше",
  "alerts.leafWetnessGreaterThanThreshold": "Влажность листьев выше порога {value}{unit}",
  "alerts.leafWetnessLessThan": "Влажность листьев ниже",
  "alerts.leafWetnessLessThanThreshold": "Влажность листьев ниже порога {value}{unit}",
  "alerts.myAlerts": "Мои оповещения",
  "alerts.noAlertsForStation": "Для этой станции еще нет настроенных оповещений",
  "alerts.noConfiguredAlert": "У вас еще нет настроенных оповещений, начните добавлять их.",
  "alerts.noiseGreaterThan": "Шум выше, чем",
  "alerts.noiseGreaterThanThreshold": "Шум превышает порог {value}{unit}",
  "alerts.noiseLessThan": "Шум менее",
  "alerts.noiseLessThanThreshold": "Шум ниже порога {value}{unit}",
  "alerts.noteOnConditions": "Обратите внимание, что оповещение срабатывает, когда проверяются все приведенные ниже условия.",
  "alerts.noTriggerHistory": "Это оповещение ещё не срабатывало.",
  "alerts.pm10GreaterThan": "PM 10 больше, чем",
  "alerts.pm10GreaterThanThreshold": "PM 10 превышает пороговое значение {value}{unit}",
  "alerts.pm10LessThan": "PM 10 менее",
  "alerts.pm10LessThanThreshold": "PM 10 ниже порогового значения {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 больше, чем",
  "alerts.pm1GreaterThanThreshold": "PM 1 превышает пороговое значение {value}{unit}",
  "alerts.pm1LessThan": "PM 1 менее",
  "alerts.pm1LessThanThreshold": "PM 1 ниже порогового значения {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 больше, чем",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 превышает пороговое значение {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 менее",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 ниже порогового значения {value}{unit}",
  "alerts.postStormSummary": "Сводка после дождя",
  "alerts.postStormSynopsisHelper": "Вы получите уведомление со сводкой после окончания каждого дождя.",
  "alerts.postStormSynopsisSoleCondition": "Сводку после дождя нельзя сочетать с другими условиями.",
  "alerts.precipitationGreaterThan": "Часовые осадки больше",
  "alerts.precipitationGreaterThanThreshold": "Часовые осадки превышают порог {value}{unit}",
  "alerts.pressureGreaterThan": "Давление больше, чем",
  "alerts.pressureGreaterThanThreshold": "Давление превышает пороговое значение {value}{unit}",
  "alerts.pressureLessThan": "Давление менее",
  "alerts.pressureLessThanThreshold": "Давление ниже порогового значения {value}{unit}",
  "alerts.pushPromptAccept": "Включить уведомления",
  "alerts.pushPromptBody": "Оповещения вашей станции приходят в виде уведомлений. Включите их, чтобы не пропустить ни одного.",
  "alerts.pushPromptBodyCreated": "Оповещение сохранено. Включите уведомления, чтобы получить его, когда оно сработает.",
  "alerts.pushPromptTitle": "Получайте уведомление, когда срабатывают ваши оповещения",
  "alerts.rainRateGreaterThan": "Интенсивность дождя больше",
  "alerts.rainRateGreaterThanThreshold": "Интенсивность дождя превышает порог {value}{unit}",
  "alerts.sensorNotReporting": "Этот датчик сейчас не передаёт данные. Оповещение возобновится, когда он снова начнёт их передавать.",
  "alerts.soilMoistureGreaterThan": "Влажность почвы выше",
  "alerts.soilMoistureGreaterThanThreshold": "Влажность почвы выше порога {value}{unit}",
  "alerts.soilMoistureLessThan": "Влажность почвы ниже",
  "alerts.soilMoistureLessThanThreshold": "Влажность почвы ниже порога {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Солнечная радиация превышает",
  "alerts.solarRadiationGreaterThanThreshold": "Солнечное излучение превышает порог {value}{unit}",
  "alerts.solarRadiationLessThan": "Солнечная радиация менее",
  "alerts.solarRadiationLessThanThreshold": "Солнечная радиация ниже порога {value}{unit}",
  "alerts.stationAlerts": "Оповещения для этой станции",
  "alerts.stationNoLongerReports": "Эта станция больше не передаёт данные, поэтому это оповещение не может сработать.",
  "alerts.stormChartUnavailable": "История осадков для этого дождя недоступна.",
  "alerts.stormDetail": "Сводка дождя",
  "alerts.stormDuration": "Продолжительность",
  "alerts.stormEnd": "Окончание",
  "alerts.stormPeakRate": "Максимальная интенсивность дождя",
  "alerts.stormStart": "Начало",
  "alerts.stormTotal": "Всего осадков",
  "alerts.temperatureGreaterThan": "Температура выше",
  "alerts.temperatureGreaterThanThreshold": "Температура превышает пороговое значение {value}{unit}",
  "alerts.temperatureLessThan": "Температура менее",
  "alerts.temperatureLessThanThreshold": "Температура ниже порогового значения {value}{unit}",
  "alerts.thresholdOutOfRange": "Должно быть между {min} и {max}",
  "alerts.thswGreaterThan": "THSW более",
  "alerts.thswGreaterThanThreshold": "THSW выше порогового значения {value}{unit}",
  "alerts.thswLessThan": "THSW менее",
  "alerts.thswLessThanThreshold": "THSW ниже порогового значения {value}{unit}",
  "alerts.thwGreaterThan": "THW более",
  "alerts.thwGreaterThanThreshold": "THW выше порогового значения {value}{unit}",
  "alerts.thwLessThan": "THW менее",
  "alerts.thwLessThanThreshold": "THW ниже порогового значения {value}{unit}",
  "alerts.triggerHistory": "История оповещения",
  "alerts.uvGreaterThan": "УФ-индекс больше, чем",
  "alerts.uvGreaterThanThreshold": "УФ-индекс превышает пороговое значение {value}{unit}",
  "alerts.uvLessThan": "УФ-индекс менее",
  "alerts.uvLessThanThreshold": "УФ-индекс меньше порогового значения {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Видимость превышает порог {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Видимость меньше порога {value}{unit}",
  "alerts.visiblityGreaterThan": "Видимость более",
  "alerts.visiblityLessThan": "Видимость менее",
  "alerts.whichMeasure": "По какому показателю вы хотите получать оповещения?",
  "alerts.whichModule": "По какому модулю вы хотите получать оповещения?",
  "alerts.whichSensor": "По какому датчику вы хотите получать оповещения?",
  "alerts.windChillGreaterThan": "Ветро-холодовой индекс более",
  "alerts.windChillGreaterThanThreshold": "Ветро-холодовой индекс выше порогового значения {value}{unit}",
  "alerts.windChillLessThan": "Ветро-холодовой индекс менее",
  "alerts.windChillLessThanThreshold": "Ветро-холодовой индекс ниже порогового значения {value}{unit}",
  "alerts.windSpeedGreaterThan": "Скорость ветра более",
  "alerts.windSpeedGreaterThanThreshold": "Скорость ветра превышает порог {value}{unit}",
  "alerts.windSpeedLessThan": "Скорость ветра менее",
  "alerts.windSpeedLessThanThreshold": "Скорость ветра ниже порога {value}{unit}",
  "appUpdate.openInBrowser": "Открыть в браузере",
  "appUpdate.reload": "Перезагрузить",
  "appUpdate.update": "Обновить",
  "appUpdate.updateAvailable": "Доступно обновление",
  "appUpdate.updateAvailableOpenAppStore": "Нажмите, чтобы открыть App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Нажмите, чтобы открыть Google Play",
  "appUpdate.updateAvailableVersion": "Доступно обновление: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Требуется обновление вашего приложения. Посетите Google Play для обновления.",
  "appUpdate.upgradeRequiredIos": "Требуется обновление вашего приложения. Посетите App Store для обновления.",
  "appUpdate.upgradeRequiredTitle": "Обновите SmartMixin, чтобы продолжить",
  "appUpdate.webUpdateAvailable": "Доступна новая версия SmartMixin. Перезагрузите страницу, чтобы начать ею пользоваться.",
  "astral.aboveHorizonAllDay": "Весь день над горизонтом",
  "astral.aboveTheHorizon": "над горизонтом",
  "astral.apparentSize": "Видимый размер",
  "astral.apparentSizeAcross": "{size} в поперечнике",
  "astral.astronomicalDawn": "Астрономический рассвет",
  "astral.astronomicalDusk": "Астрономические сумерки",
  "astral.belowHorizonAllDay": "Весь день под горизонтом",
  "astral.belowHorizonSince": "Под горизонтом с {time}",
  "astral.belowHorizonSinceOn": "Под горизонтом с {day} {time}",
  "astral.brightAllNight": "Светло всю ночь — темнота не наступает",
  "astral.brightestMoment": "Самый светлый момент",
  "astral.civilDawn": "Гражданский рассвет",
  "astral.civilDusk": "Гражданские сумерки",
  "astral.darkSkyBetween": "Тёмное небо {from} → {to}",
  "astral.darkSkyWindow": "Тёмное небо {from} → {to} · {duration} без Луны",
  "astral.dayLength": "Долгота дня",
  "astral.daylightThroughTheYear": "Долгота дня в течение года",
  "astral.dayOfCycle": "день {day} из {total}",
  "astral.doesNotOccurToday": "Сегодня не наступает",
  "astral.domeHint": "Потяните, чтобы пройти по ночи",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Самый ранний восход",
  "astral.earliestSunset": "Самый ранний закат",
  "astral.equinox": "Равноденствие",
  "astral.equinoxIn": "Равноденствие через {days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
  "astral.evening": "Вечер",
  "astral.exactPhaseAt": "Точно в {time}",
  "astral.firstQuarter": "Первая четверть",
  "astral.firstSunriseIn": "Первый восход через {days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
  "astral.firstSunsetIn": "Первый закат через {days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
  "astral.fullMoon": "Полнолуние",
  "astral.goldenHourBegins": "Начало золотого часа",
  "astral.goldenHourEnds": "Конец золотого часа",
  "astral.highestPoint": "Высшая точка",
  "astral.inDays": "через {days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
  "astral.lastQuarter": "Последняя четверть",
  "astral.latestSunrise": "Самый поздний восход",
  "astral.latestSunset": "Самый поздний закат",
  "astral.litShort": "Освещ.",
  "astral.longestDay": "Самый длинный день",
  "astral.lowestPoint": "Низшая точка",
  "astral.maxAltitudeShort": "Макс.",
  "astral.midday": "Полдень",
  "astral.midnightSun": "Полярный день",
  "astral.midnightSunPeriod": "Полярный день",
  "astral.milestoneFootnotePolar": "Здесь солнце {days, plural, one {# день} few {# дня} many {# дней} other {# дня}} в году не восходит и не заходит, поэтому вместо обычных крайних восходов и закатов список показывает, когда это происходит.",
  "astral.milestoneFootnoteTemperate": "Самый ранний закат и самый поздний восход не приходятся на самый короткий день — эти две даты задаёт уравнение времени, а не солнцестояние.",
  "astral.moon": "Луна",
  "astral.moonAltitude": "Высота",
  "astral.moonDirection": "Азимут",
  "astral.moonDistance": "Расстояние",
  "astral.moonlessFor": "{duration} без Луны",
  "astral.moonPhases": "Фазы Луны",
  "astral.moonrise": "Восход Луны",
  "astral.moonset": "Заход Луны",
  "astral.moonUpAllNight": "Луна над горизонтом всю ночь",
  "astral.moonWashesOutNight": "Луна над горизонтом с {rise} до {set} и засвечивает всю ночь",
  "astral.morning": "Утро",
  "astral.nauticalDawn": "Навигационный рассвет",
  "astral.nauticalDusk": "Навигационные сумерки",
  "astral.newMoon": "Новолуние",
  "astral.nextDay": "+1 день",
  "astral.nextProperlyDarkNight": "Следующая по-настоящему тёмная ночь",
  "astral.nextRise": "следующий восход в {time}",
  "astral.nextRiseOn": "следующий восход {day} в {time}",
  "astral.nextSevenNights": "Ближайшие семь ночей",
  "astral.nightDate": "Дата",
  "astral.noAstronomicalDarknessTonight": "Этой ночью нет астрономической темноты",
  "astral.noDarkNightAhead": "Нет в ближайшие две недели",
  "astral.noStationLocation": "Местоположение неизвестно",
  "astral.noStationLocationDescription": "У этой станции нет сохранённого местоположения, поэтому для неё нельзя рассчитать солнце и луну.",
  "astral.noSunriseToday": "Сегодня солнце не восходит",
  "astral.nowAtBearing": "сейчас {altitude} · азимут {direction}",
  "astral.observing": "Наблюдение",
  "astral.ofDaylightLeft": "светового дня осталось",
  "astral.overTheNextThreeWeeks": "за следующие 3 недели",
  "astral.percentLit": "{percent} освещено",
  "astral.polarNight": "Полярная ночь",
  "astral.polarNightPeriod": "Полярная ночь",
  "astral.rightNow": "Сейчас",
  "astral.riseShort": "Восход",
  "astral.setShort": "Заход",
  "astral.shortestDay": "Самый короткий день",
  "astral.solarNoon": "Солнечный полдень",
  "astral.solstice": "Солнцестояние",
  "astral.sunBelowHorizon": "Солнце на {degrees}° ниже горизонта",
  "astral.sunEvents": "Солнечные события",
  "astral.sunNeverDarkEnough": "Солнце не опускается на 18° ниже горизонта",
  "astral.sunNeverSets": "Солнце не заходит",
  "astral.sunrise": "Восход",
  "astral.sunriseAndSunset": "Восход и закат",
  "astral.sunriseAt": "Восход в {time}",
  "astral.sunset": "Закат",
  "astral.sunsetAt": "Закат в {time}",
  "astral.thisYearAtNorth": "В этом году на {degrees}° с. ш.",
  "astral.thisYearAtSouth": "В этом году на {degrees}° ю. ш.",
  "astral.tonight": "Этой ночью",
  "astral.twilightAllNight": "Сумерки всю ночь — темнота не наступает",
  "astral.upFor": "{duration} над горизонтом",
  "astral.usableLight": "Светлое время",
  "astral.vsAverage": "{percent} от среднего",
  "astral.vsYesterday": "по сравнению со вчерашним днём",
  "astral.waningCrescent": "Убывающий серп",
  "astral.waningGibbous": "Убывающая луна",
  "astral.waxingCrescent": "Растущий серп",
  "astral.waxingGibbous": "Растущая луна",
  "astral.whereToLook": "Куда смотреть",
  "astral.withoutTheMoon": "{duration} без Луны",
  "auth.alreadyHaveAccount": "Уже есть аккаунт?",
  "auth.authContainerTagline": "Ваша персональная панель погоды. Подключите свои станции и получайте данные в реальном времени под рукой.",
  "auth.backToLogin": "Вернуться к входу",
  "auth.checkYourEmail": "Проверьте вашу электронную почту",
  "auth.continueWithApple": "Продолжить с Apple",
  "auth.continueWithFacebook": "Продолжить с Facebook",
  "auth.continueWithGoogle": "Продолжить с Google",
  "auth.email": "Адрес электронной почты",
  "auth.emailRequiredLoginFacebook": "Требуется разрешение на использование электронной почты.",
  "auth.emailVerification": "Подтверждение адреса электронной почты",
  "auth.emailVerificationFailure": "Возникла проблема с подтверждением вашей электронной почты.",
  "auth.emailVerificationSuccess": "Ваш адрес электронной почты успешно подтвержден.",
  "auth.firstName": "Имя",
  "auth.forgotPassword": "Забыли пароль?",
  "auth.forgotPasswordSubtitle": "Введите адрес электронной почты, и мы отправим вам ссылку для сброса пароля.",
  "auth.lastName": "Фамилия",
  "auth.login": "Войти",
  "auth.loginSubtitle": "С возвращением! Пожалуйста, введите свои данные.",
  "auth.loginToSmartMixinDescription": "Войдите в SmartMixin, чтобы получить доступ к своим метеостанциям, просматривать аналитику и управлять личной панелью погоды.",
  "auth.logout": "Выйти",
  "auth.logoutConfirmation": "Выйти из аккаунта?",
  "auth.noAccountYet": "Еще нет аккаунта?",
  "auth.or": "или",
  "auth.password": "Пароль",
  "auth.passwordReset": "Восстановление пароля",
  "auth.passwordResetSuccess": "Ваш пароль был успешно изменен.",
  "auth.register": "Зарегистрироваться",
  "auth.registerDescription": "Создайте бесплатный аккаунт SmartMixin для подключения ваших метеостанций, отслеживания погодных данных и доступа к мощным аналитическим инструментам.",
  "auth.registerSubtitle": "Создайте аккаунт, чтобы начать.",
  "auth.restorePassword": "Восстановить пароль",
  "auth.restorePasswordSuccess": "Мы только что отправили вам ссылку для сброса пароля на адрес {emailAddress} с дальнейшими инструкциями.",
  "auth.sendReset": "Отправить инструкции по сбросу",
  "auth.signInRowDescription": "Ваши места, станции и оповещения на всех ваших устройствах",
  "auth.signInRowTitle": "Войти или зарегистрироваться",
  "auth.signInWithApple": "Вход с Apple",
  "auth.socialAccount": "или используйте свою учетную запись",
  "auth.staffVerificationCode": "Код подтверждения",
  "auth.staffVerificationExpiresIn": "Подтверждено. Истекает через {duration}.",
  "auth.staffVerificationInvalidCode": "Неверный код. Попробуйте ещё раз.",
  "auth.staffVerificationLoginAsStopped": "Login As остановлен: чтобы продолжить, введите код подтверждения на экране Debug.",
  "auth.staffVerificationNotEnrolled": "Для вашей учётной записи не настроено приложение-аутентификатор. Добавьте его в настройках безопасности панели администратора.",
  "auth.staffVerificationPasskey": "Подтвердить ключом доступа",
  "auth.staffVerificationPasskeyExpired": "Срок действия запроса ключа доступа истёк. Попробуйте ещё раз.",
  "auth.staffVerificationPasskeyFailed": "Не удалось подтвердить ключ доступа. Попробуйте ещё раз или введите код.",
  "auth.staffVerificationPasskeyNotEnrolled": "На этом телефоне нет ключа доступа для вашей учётной записи. Добавьте его с этого телефона в настройках безопасности панели администратора или введите код.",
  "auth.staffVerificationPasskeySetupLink": "Добавить ключ доступа",
  "auth.staffVerificationPasskeyUnavailable": "Ключи доступа здесь использовать нельзя. Вместо этого введите код.",
  "auth.staffVerificationPrompt": "Введите 6-значный код из приложения-аутентификатора или код восстановления, чтобы использовать Login As и поиск пользователей.",
  "auth.staffVerificationPromptPasskey": "Используйте ключ доступа или введите 6-значный код из приложения-аутентификатора либо код восстановления, чтобы использовать Login As и поиск пользователей.",
  "auth.staffVerificationSetupLink": "Добавить приложение-аутентификатор",
  "auth.staffVerificationSubmit": "Подтвердить",
  "auth.staffVerificationTitle": "Проверка сотрудника",
  "calendar.afternoon": "День",
  "calendar.april": "Апрель",
  "calendar.august": "Август",
  "calendar.changePeriod": "Период: {period}. Изменить период",
  "calendar.currentDay": "Сегодня",
  "calendar.dateFormat": "Формат даты",
  "calendar.day": "День",
  "calendar.december": "Декабрь",
  "calendar.durationHours": "{hours} ч",
  "calendar.durationHoursMinutes": "{hours} ч {minutes} мин",
  "calendar.durationMinutes": "{minutes} мин",
  "calendar.durationMinutesSeconds": "{minutes} мин {seconds} с",
  "calendar.durationSeconds": "{seconds} с",
  "calendar.earlierYears": "Предыдущие годы",
  "calendar.endTime": "Время окончания",
  "calendar.evening": "Вечер",
  "calendar.february": "Февраль",
  "calendar.goToNextDay": "Следующий день",
  "calendar.goToNextMonth": "Следующий месяц",
  "calendar.goToNextWeek": "Следующая неделя",
  "calendar.goToNextYear": "Следующий год",
  "calendar.goToPreviousDay": "Предыдущий день",
  "calendar.goToPreviousMonth": "Предыдущий месяц",
  "calendar.goToPreviousWeek": "Предыдущая неделя",
  "calendar.goToPreviousYear": "Предыдущий год",
  "calendar.hour": "Час",
  "calendar.hoursCount": "{count, plural, one {# час} few {# часа} many {# часов} other {# часа}}",
  "calendar.hoursShort": "ч",
  "calendar.hoursShortCount": "{count, plural, one {# ч} few {# ч} many {# ч} other {# ч}}",
  "calendar.january": "Январь",
  "calendar.july": "Июль",
  "calendar.june": "Июнь",
  "calendar.last12Hours": "Последние 12 часов",
  "calendar.last24Hours": "Последние 24 часа",
  "calendar.last24HoursTo": "24 ч до {time}",
  "calendar.last24HoursToYesterday": "24 ч, вчера до {time}",
  "calendar.last30Days": "Последние 30 дней",
  "calendar.last3Hours": "Последние 3 часа",
  "calendar.last6Hours": "Последние 6 часов",
  "calendar.last7Days": "Последние 7 дней",
  "calendar.lastHour": "Последний час",
  "calendar.laterYears": "Следующие годы",
  "calendar.march": "Март",
  "calendar.max": "Макс",
  "calendar.may": "Май",
  "calendar.month": "Месяц",
  "calendar.monthTotal": "Всего за месяц",
  "calendar.morning": "Утро",
  "calendar.nextHours": "Следующие часы",
  "calendar.night": "Ночь",
  "calendar.november": "Ноябрь",
  "calendar.october": "Октябрь",
  "calendar.oneDay": "1 день",
  "calendar.oneHour": "1 час",
  "calendar.oneMonth": "1 месяц",
  "calendar.oneWeek": "1 неделя",
  "calendar.periodRangeSpoken": "с {start} по {end}",
  "calendar.previous24Hours": "Предыдущие 24 часа",
  "calendar.previous30Days": "Предыдущие 30 дней",
  "calendar.previous7Days": "Предыдущие 7 дней",
  "calendar.previousDay": "Предыдущий день",
  "calendar.previousHours": "Предыдущие часы",
  "calendar.previousMonth": "Предыдущий месяц",
  "calendar.previousWeek": "Предыдущая неделя",
  "calendar.previousYear": "Предыдущий год",
  "calendar.sameDayLastYear": "В тот же день в прошлом году",
  "calendar.sameMonthLastYear": "Тот же месяц прошлого года",
  "calendar.selectADate": "Выберите дату",
  "calendar.selectAggregation": "Выберите отображаемое значение",
  "calendar.selectAMonth": "Выберите месяц",
  "calendar.selectAYear": "Выберите год",
  "calendar.selectGranularity": "Выберите степень детализации",
  "calendar.selectPeriod": "Выберите период",
  "calendar.september": "Сентябрь",
  "calendar.sixHours": "6 часов",
  "calendar.startTime": "Время начала",
  "calendar.thirtyMinutes": "30 минут",
  "calendar.threeHours": "3 часа",
  "calendar.timezone": "Часовой пояс",
  "calendar.today": "Сегодня",
  "calendar.untilChanged": "До изменения",
  "calendar.untilTime": "До {time}",
  "calendar.untilTodayAt": "Сегодня до {time}",
  "calendar.untilTomorrowAt": "Завтра до {time}",
  "calendar.use24HourFormat": "Использовать 24-часовой формат",
  "calendar.week": "Неделя",
  "calendar.year": "Год",
  "calendar.yearToDate": "С начала года",
  "calendar.yesterday": "Вчера",
  "charts.averageOverThePeriod": "В среднем за период",
  "charts.calendarView": "Календарный вид",
  "charts.charts": "Графики",
  "charts.chartView": "Вид графика",
  "charts.comparison": "Сравнение",
  "charts.customizeComparisonMetrics": "Настройка показателей",
  "charts.customizeComparisonMetricsDescription": "Перетащите элементы, чтобы переупорядочить метрики сравнения. Коснитесь значка глаза, чтобы показать или скрыть показатели.",
  "charts.loading": "Загрузка графика",
  "charts.maxOverThePeriod": "Максимум за период",
  "charts.measureToDisplay": "Отображаемый показатель",
  "charts.minMaxRange": "Мин. / Макс.",
  "charts.noDataForThisPeriod": "Нет данных за этот период",
  "charts.observations": "Наблюдения",
  "charts.observedTemperature": "Наблюдаемая температура",
  "charts.seriesTableDate": "Дата",
  "charts.showComparison": "Показать сравнение",
  "charts.stationComparison": "Сравнение станций",
  "charts.stationComparisonDescription": "Сравните исторические данные о погоде с другой станцией",
  "charts.sumOverThePeriod": "Накоплено за период",
  "charts.tableLabel": "Таблица: {chart}",
  "charts.toggleSeries": "Показать или скрыть: {series}",
  "charts.viewAsChart": "График",
  "charts.viewAsList": "Список",
  "charts.viewAsPeriods": "Периоды",
  "charts.viewAsTable": "Таблица",
  "charts.viewLabel": "Вид: {chart}",
  "common.add": "Добавить",
  "common.altitude": "Высота",
  "common.analysis": "Анализ",
  "common.average": "Среднее",
  "common.back": "Назад",
  "common.backToHome": "Вернуться на главную",
  "common.cancel": "Отмена",
  "common.cannotBeEmpty": "Это поле не может быть пустым.",
  "common.clearSearch": "Очистить поиск",
  "common.close": "Закрыть",
  "common.dailyForecast": "Ежедневный прогноз",
  "common.default": "По умолчанию",
  "common.delete": "Удалить",
  "common.details": "Подробности",
  "common.edit": "Редактировать",
  "common.exitFullscreen": "Выйти из полноэкранного режима",
  "common.forecast": "Прогноз",
  "common.frequency": "Частота",
  "common.full": "Полный",
  "common.fullscreen": "Полноэкранный режим",
  "common.help": "Помощь",
  "common.hidden": "Скрытые",
  "common.high": "Высокий",
  "common.iDontKnowYet": "Я еще не знаю",
  "common.indoor": "В помещении",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Последнее обновление",
  "common.low": "Низкий",
  "common.mapUnavailable": "Карта недоступна",
  "common.maximum": "Максимум",
  "common.medium": "Средний",
  "common.minimum": "Минимум",
  "common.more": "Ещё",
  "common.moreInformation": "Больше информации",
  "common.moveDown": "Переместить вниз",
  "common.moveUp": "Переместить вверх",
  "common.no": "Нет",
  "common.noAccountNeeded": "Аккаунт не требуется",
  "common.noItemsAvailable": "Нет доступных элементов",
  "common.nothingSelected": "Ничего не выбрано",
  "common.notNow": "Не сейчас",
  "common.now": "Сейчас",
  "common.openSettings": "Откройте настройки",
  "common.outdoor": "На улице",
  "common.pageNotFound": "Страница не найдена",
  "common.pageNotFoundDescription": "Страница, которую вы ищете, не существует или была перемещена.",
  "common.rain": "Дождь",
  "common.reorderCancel": "Перемещение отменено: {item}. Снова на позиции {position} из {count}.",
  "common.reorderEnd": "Отпущено: {item}. Позиция {position} из {count}.",
  "common.reorderInstructions": "Чтобы переместить этот элемент, нажмите пробел или Enter, выберите его место стрелками вверх и вниз, затем снова нажмите пробел или Enter, чтобы отпустить его, или Escape для отмены.",
  "common.reorderOver": "{item} — теперь на позиции {position} из {count}.",
  "common.reorderStart": "Взято: {item}. Позиция {position} из {count}.",
  "common.search": "Поиск",
  "common.share": "Поделиться",
  "common.shareImageFailed": "Не удалось поделиться изображением",
  "common.shareYourWeather": "Поделитесь своей погодой",
  "common.skip": "Пропустить",
  "common.snackbarWithAction": "{message}. Действие: {action}",
  "common.unknown": "Неизвестный",
  "common.validate": "Подтвердить",
  "common.validEmail": "Требуется действительный адрес электронной почты.",
  "common.very_low": "Очень низкий",
  "common.weatherObservations": "Наблюдения за погодой",
  "common.welcome": "Добро пожаловать в SmartMixin!",
  "common.wind": "Ветер",
  "common.yes": "Да",
  "common.zoomImage": "Увеличить изображение",
  "compass.E": "В",
  "compass.E_long": "Восток",
  "compass.ENE": "ВСВ",
  "compass.ENE_long": "Восток-северо-восток",
  "compass.ESE": "ВЮВ",
  "compass.ESE_long": "Восток-юго-восток",
  "compass.N": "С",
  "compass.N_long": "Север",
  "compass.NE": "СВ",
  "compass.NE_long": "Северо-восток",
  "compass.NNE": "ССВ",
  "compass.NNE_long": "Северо-северо-восток",
  "compass.NNW": "ССЗ",
  "compass.NNW_long": "Северо-северо-запад",
  "compass.NW": "СЗ",
  "compass.NW_long": "Северо-запад",
  "compass.S": "Ю",
  "compass.S_long": "Юг",
  "compass.SE": "ЮВ",
  "compass.SE_long": "Юго-восток",
  "compass.SSE": "ЮЮВ",
  "compass.SSE_long": "Юго-юго-восток",
  "compass.SSW": "ЮЮЗ",
  "compass.SSW_long": "Юго-юго-запад",
  "compass.SW": "ЮЗ",
  "compass.SW_long": "Юго-запад",
  "compass.W": "З",
  "compass.W_long": "Запад",
  "compass.WNW": "ЗСЗ",
  "compass.WNW_long": "Запад-северо-запад",
  "compass.WSW": "ЗЮЗ",
  "compass.WSW_long": "Запад-юго-запад",
  "dashboard.currentObservations": "Текущие наблюдения",
  "dashboard.currentRainEvent": "Текущий дождь",
  "dashboard.currentWeatherConditions": "Текущая погода",
  "dashboard.customizeDashboard": "Настроить",
  "dashboard.customizeDashboardDescription": "Перетащите элементы, чтобы изменить порядок панели. Нажмите на значок глаза, чтобы показать или скрыть разделы.",
  "dashboard.customizeNetatmoDescription": "Перетащите модули, чтобы изменить их порядок в разделе «На улице» или «В помещении». Нажмите на значок глаза, чтобы показать или скрыть модуль.",
  "dashboard.customizeNetatmoPublicDescription": "Перетащите модули, чтобы изменить их порядок. Нажмите на значок глаза, чтобы показать или скрыть модуль.",
  "dashboard.dashboard": "Панель приборов",
  "dashboard.dayRangeExpected": "{value} ожидается в {time}",
  "dashboard.dayRangeReached": "{value} в {time}",
  "dashboard.dayRangeSteady": "Стабильно {value} весь день",
  "dashboard.hiddenSensors": "Скрытые датчики",
  "dashboard.hideSensor": "Скрыть: {sensor}",
  "dashboard.lastRainEvent": "Последний дождь",
  "dashboard.lastVisibleSensor": "Хотя бы один датчик должен оставаться видимым.",
  "dashboard.manageSensors": "Управление датчиками",
  "dashboard.manageSensorsDescription": "Перетаскивайте элементы для изменения порядка датчиков. Нажмите на значок глаза, чтобы показать или скрыть датчики. Нажмите на название, чтобы переименовать.",
  "dashboard.manageSensorsDescriptionWeb": "Нажмите на карандаш, чтобы переименовать датчик, перетащите его за маркер, чтобы изменить порядок списка, и нажмите на глаз, чтобы скрыть или показать его.",
  "dashboard.moveSensor": "Переместить: {sensor}",
  "dashboard.pressureSummary": "Сводка давления",
  "dashboard.rainEvents": "Дождевые события",
  "dashboard.rainSummary": "Сводка дождя",
  "dashboard.renameSensor": "Переименовать: {sensor}",
  "dashboard.shareOutdoorMeasures": "Поделитесь своими уличными измерениями",
  "dashboard.shareOutdoorMeasuresDescription": "Участвуйте в сообществе SmartMixin: сделайте свои уличные измерения видимыми для других. Измерения в помещении никогда не передаются.",
  "dashboard.showSensor": "Показать: {sensor}",
  "dashboard.temperatureSummary": "Сводка температуры",
  "dashboard.useDefaultSensorName": "Использовать имя по умолчанию",
  "dashboard.windSummary": "Сводка по ветру",
  "devices.batteryLevel": "Уровень заряда батареи",
  "devices.firmwareVersion": "Версия прошивки",
  "devices.moduleCount": "{count, plural, one {# модуль} few {# модуля} many {# модулей} other {# модуля}}",
  "devices.moduleType": "Тип модуля",
  "devices.noNetatmoWeatherStationYet": "У вас еще нет метеостанции Netatmo.",
  "devices.noOutdoorModule": "Для этой станции нет работающего уличного модуля.",
  "devices.notReachable": "Нет связи",
  "devices.serialNumber": "Серийный номер",
  "devices.signalAverage": "Средний",
  "devices.signalBad": "Слабый",
  "devices.signalGood": "Хороший",
  "devices.signalStrength": "Сила сигнала",
  "devices.signalUnknown": "Неизвестный",
  "devices.visitNetatmoWebsite": "Посетите сайт Netatmo",
  "devices.wifiStrength": "Сила сигнала Wi-Fi",
  "forecastMaps.addColor": "Добавить цвет",
  "forecastMaps.addLayer": "Добавить слой",
  "forecastMaps.autoDescription": "Лучшая доступная для этого вида",
  "forecastMaps.autoDescriptionFree": "Без Premium: {model}",
  "forecastMaps.autoPreview": "Авто",
  "forecastMaps.autoSwitched": "Теперь показана модель {model}: {previous} охватывает {coverage, number, percent} этого вида",
  "forecastMaps.backToMaps": "Назад к картам",
  "forecastMaps.build": "Сгенерировать",
  "forecastMaps.buildCompleted": "Генерация завершена",
  "forecastMaps.builderMetaDescription": "Создавайте собственные прогнозные карты из слоёв метеорологических моделей.",
  "forecastMaps.builderTitle": "Конструктор карт",
  "forecastMaps.buildFailed": "Не удалось сгенерировать. Попробуйте ещё раз.",
  "forecastMaps.buildNotPossible": "Эту карту пока нельзя сгенерировать — нет доступных прогнозных данных.",
  "forecastMaps.buildProgress": "Отрисовка… {completed}/{total} шагов",
  "forecastMaps.buildStarting": "Запуск генерации…",
  "forecastMaps.byModel": "По модели",
  "forecastMaps.byZone": "По зоне",
  "forecastMaps.colormap": "Цветовая шкала",
  "forecastMaps.colormapCustom": "Свои цвета",
  "forecastMaps.colormapGroupDomain": "Метеорологические шаблоны",
  "forecastMaps.colormapGroupMatplotlib": "Научные шаблоны",
  "forecastMaps.colorStop": "Цвет {position}",
  "forecastMaps.configUnavailable": "Эта прогнозная карта недоступна. Вместо неё показана карта {name}.",
  "forecastMaps.contourLevels": "Уровни изолиний",
  "forecastMaps.countryCanada": "Канада",
  "forecastMaps.countryFrance": "Франция",
  "forecastMaps.countryGermany": "Германия",
  "forecastMaps.countryItaly": "Италия",
  "forecastMaps.countryScandinavia": "Скандинавия",
  "forecastMaps.countrySpain": "Испания",
  "forecastMaps.countrySwitzerland": "Швейцария",
  "forecastMaps.countryUnitedStates": "Соединённые Штаты",
  "forecastMaps.coverageUnknown": "Область неизвестна",
  "forecastMaps.coversView": "Охватывает {coverage, number, percent} этого вида",
  "forecastMaps.customColormapMinColors": "Своя цветовая шкала требует не менее двух цветов",
  "forecastMaps.customExtent": "Свой охват",
  "forecastMaps.displayName": "Отображаемое имя",
  "forecastMaps.downscaling": "Коэффициент прореживания стрелок ветра",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Нарисовать область",
  "forecastMaps.east": "Восток",
  "forecastMaps.extentDrawHint": "Проведите по карте, чтобы нарисовать область",
  "forecastMaps.extentInvalid": "Запад должен быть меньше востока, а юг — меньше севера",
  "forecastMaps.frameTime": "Время прогноза",
  "forecastMaps.height": "Высота (дюймы)",
  "forecastMaps.hourOffset": "+{hour} ч",
  "forecastMaps.inThisArea": "В этой области",
  "forecastMaps.invalidHexColor": "Недопустимый цвет — используйте #RRGGBB",
  "forecastMaps.layerHasErrors": "В этом слое есть ошибки",
  "forecastMaps.layers": "Слои",
  "forecastMaps.layerTypeBarbs": "Стрелки ветра",
  "forecastMaps.layerTypeContour": "Изолинии",
  "forecastMaps.layerTypeFilledContour": "Залитые изолинии",
  "forecastMaps.layerTypeMagnitude": "Модуль",
  "forecastMaps.layerTypeRaster": "Растр",
  "forecastMaps.layerTypeVectorField": "Векторное поле",
  "forecastMaps.leave": "Выйти",
  "forecastMaps.levelsCount": "Количество",
  "forecastMaps.levelsInvalid": "Недопустимые уровни изолиний",
  "forecastMaps.levelsModeArange": "Фиксированный шаг",
  "forecastMaps.levelsModeExplicit": "Явные значения",
  "forecastMaps.levelsModeLinspace": "Равномерно распределённые (количество)",
  "forecastMaps.levelsStep": "Шаг",
  "forecastMaps.levelsValues": "Значения",
  "forecastMaps.levelsValuesHint": "Через запятую, по возрастанию",
  "forecastMaps.loadingMaps": "Загрузка карт…",
  "forecastMaps.localTimeHint": "Показано в вашем местном времени",
  "forecastMaps.lockedConfig": "{model} — модель Premium. Вместо неё показана модель {fallback}.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Описание",
  "forecastMaps.mapName": "Название карты",
  "forecastMaps.mapNameRequired": "Введите название",
  "forecastMaps.mapSettings": "Настройки карты",
  "forecastMaps.maxLayersReached": "Эта карта достигла максимума в {max} слоёв.",
  "forecastMaps.maxValue": "Максимальное значение",
  "forecastMaps.memoryBudgetExceeded": "Разрешение превышает бюджет отрисовки — уменьшите DPI или высоту",
  "forecastMaps.memoryBudgetUsage": "Бюджет отрисовки: {percent}%",
  "forecastMaps.metaDescription": "Анимированные прогнозные карты, построенные по расчётам моделей погоды.",
  "forecastMaps.metric": "Величина",
  "forecastMaps.metricRequired": "Выберите величину",
  "forecastMaps.metricUnavailable": "Недоступно для этой модели",
  "forecastMaps.minBelowMax": "Минимум должен быть меньше максимума",
  "forecastMaps.minMaxRequired": "Минимальное и максимальное значения обязательны для этого типа слоя",
  "forecastMaps.minValue": "Минимальное значение",
  "forecastMaps.modelChipAuto": "Авто · {model}",
  "forecastMaps.modelCoversView": "{model} охватывает {coverage, number, percent} этого вида",
  "forecastMaps.modelNoRun": "Пока нет завершённого прогона",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.nanClipToMin": "Ограничить минимумом",
  "forecastMaps.nanMask": "Маскировать",
  "forecastMaps.nanPolicy": "Отсутствующие данные",
  "forecastMaps.nanSkip": "Пропустить",
  "forecastMaps.noCompletedRun": "Эта карта ещё не построена. Загляните позже.",
  "forecastMaps.noLayers": "Слоёв пока нет. Добавьте слой, чтобы начать.",
  "forecastMaps.noMapsAvailable": "Прогнозные карты пока недоступны.",
  "forecastMaps.north": "Север",
  "forecastMaps.opacity": "Непрозрачность",
  "forecastMaps.openAsAnimation": "Открыть как анимацию",
  "forecastMaps.otherAreas": "Другие области",
  "forecastMaps.outsideArea": "Не охватывает эту область",
  "forecastMaps.overlayLegend": "Легенда",
  "forecastMaps.pause": "Пауза",
  "forecastMaps.play": "Воспроизвести",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Не удалось загрузить прогноз для этой точки.",
  "forecastMaps.pointValueLoading": "Загрузка прогноза…",
  "forecastMaps.pointValueUnavailable": "Нет данных для этого времени.",
  "forecastMaps.premiumModelForView": "{model} охватывает этот вид",
  "forecastMaps.premiumRequired": "Для прогнозных карт нужен Premium",
  "forecastMaps.preview": "Предпросмотр",
  "forecastMaps.previewEmptyHint": "Настройте хотя бы один корректный слой, чтобы отрисовать предпросмотр.",
  "forecastMaps.previewFailed": "Предпросмотр не удался",
  "forecastMaps.previewHour": "Час прогноза",
  "forecastMaps.previewRendering": "Отрисовка предпросмотра…",
  "forecastMaps.projection": "Проекция",
  "forecastMaps.projectionLambertConformal": "Коническая конформная Ламберта",
  "forecastMaps.projectionMercator": "Меркатора",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Стереографическая",
  "forecastMaps.regionEurope": "Европа",
  "forecastMaps.regionNorthAmerica": "Северная Америка",
  "forecastMaps.removeColor": "Удалить цвет",
  "forecastMaps.removeLayer": "Удалить слой",
  "forecastMaps.retry": "Повторить",
  "forecastMaps.run": "Расчёт: {run}",
  "forecastMaps.runNotDisplayable": "Этот расчёт нельзя показать на интерактивной карте.",
  "forecastMaps.save": "Сохранить",
  "forecastMaps.selectExtentOnMap": "Выбрать область на карте",
  "forecastMaps.showArea": "Показать область",
  "forecastMaps.showAreaOf": "Показать область, {model}",
  "forecastMaps.south": "Юг",
  "forecastMaps.switchToModel": "Переключиться на {model}",
  "forecastMaps.title": "Прогнозные карты",
  "forecastMaps.uMetric": "U-компонента",
  "forecastMaps.unitConversion": "Преобразование единиц",
  "forecastMaps.unitNone": "Нет",
  "forecastMaps.unsavedChangesBody": "У вас есть несохранённые изменения. Выйти и отменить их?",
  "forecastMaps.unsavedChangesTitle": "Несохранённые изменения",
  "forecastMaps.useCurrentView": "Использовать текущий вид",
  "forecastMaps.useModelDomain": "Выкл.: используется вся область модели",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Величины U и V должны различаться",
  "forecastMaps.valueBetween": "Должно быть между {min} и {max}",
  "forecastMaps.variable": "Переменная",
  "forecastMaps.variableMissing": "{variable}: нет данных",
  "forecastMaps.variableOnlyFrom": "{variable}: есть только в {model}",
  "forecastMaps.vectorLayerFronts": "Фронты",
  "forecastMaps.vectorLayerIsobars": "Изобары",
  "forecastMaps.vectorLayerWindBarbs": "Стрелки ветра",
  "forecastMaps.viewMap": "Посмотреть карту",
  "forecastMaps.vMetric": "V-компонента",
  "forecastMaps.west": "Запад",
  "forecastMaps.windAnimation": "Анимация ветра",
  "forecastMaps.windAnimationReduceMotion": "Отключена, пока на вашем устройстве включено уменьшение движения",
  "forecastModels.addForecastModel": "Добавить модель",
  "forecastModels.atYourStations": "Доступны на ваших станциях",
  "forecastModels.comparisonLoadError": "Не удалось загрузить сравнение прогнозных моделей",
  "forecastModels.coverageLoading": "Определяем, какие из ваших станций покрывает каждая модель…",
  "forecastModels.description_AROME": "Высокоразрешающая конвекционно-разрешающая модель Météo France над Западной Европой с разрешением 1,3 км. Лучшая в своем классе для краткосрочных прогнозов во Франции; обновляется каждые три часа.",
  "forecastModels.description_ARPEGE_EU": "Европейский вложенный домен модели ARPEGE Météo France с разрешением 10 км. Среднесрочные прогнозы над Европой, обновляются четыре раза в день.",
  "forecastModels.description_ARPEGE_GLOBAL": "Глобальная численная модель погоды Météo France с разрешением 25 км, работает до примерно 4 дней. Обновляется четыре раза в день.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI от DMI: конвекционно-разрешающая модель над северо-западной Европой — Дания, Бенилюкс, Ирландия, Великобритания и Скандинавия — с разрешением 2 км, работает до 60 часов, обновляется восемь раз в день. Содержит изменённые открытые данные DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Глобальная детерминистическая прогностическая система Environment Canada: всемирная среднесрочная модель с разрешением 15 км, работает до 10 дней, обновляется дважды в день.",
  "forecastModels.description_EC_HRDPS": "Детерминистическая прогностическая система высокого разрешения Environment Canada: конвекционно-разрешающая модель над Канадой и северной частью США с разрешением 2,5 км, работает до 48 часов, обновляется четыре раза в день.",
  "forecastModels.description_EC_RDPS": "Региональная детерминистическая прогностическая система Environment Canada: среднесрочная модель над Северной Америкой с разрешением 10 км, обновляется четыре раза в день.",
  "forecastModels.description_ECMWF_HRES": "Флагманская модель высокого разрешения (IFS) Европейского центра среднесрочных прогнозов погоды, широко признанная лучшей глобальной прогностической системой в мире. Покрывает всю планету с разрешением 25 км на срок до 15 дней, обновляется четыре раза в сутки. Содержит изменённые открытые данные ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "Флагманская среднесрочная глобальная модель NOAA. Покрывает всю планету с разрешением 25 км до 16 дней, обновляется четыре раза в день.",
  "forecastModels.description_HRRR_CONUS": "High-Resolution Rapid Refresh от NOAA: конвекционно-разрешающая модель над континентальной частью США с разрешением 3 км, обновляется ежечасно. Лучше всего подходит для очень краткосрочных прогнозов гроз и сильной погоды.",
  "forecastModels.description_ICON": "Глобальная модель ICON от DWD с разрешением 13 км, охватывающая всю планету на срок до 7,5 суток, обновляется четыре раза в день. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I от ItaliaMeteo, работающая совместно с ARPAE: конвекционно-разрешающая модель над Италией с разрешением 2,2 км, работает до 72 часов, обновляется два раза в день. Содержит открытые данные ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Контрольный прогон ICON-CH1-EPS от MeteoSwiss: конвекционно-разрешающая модель над Альпами с разрешением 1 км, работает до 33 часов, обновляется каждые три часа.",
  "forecastModels.description_ICON_CH2": "Контрольный прогон ICON-CH2-EPS от MeteoSwiss: конвекционно-разрешающая модель над Альпами — Швейцария и прилегающий альпийский регион — с разрешением 2,1 км, работает до 120 часов, обновляется четыре раза в день.",
  "forecastModels.description_ICON_DE": "Высокоразрешающая конвекционно-разрешающая модель DWD над Германией и окружающими странами с разрешением 2,2 км. Краткосрочные прогнозы обновляются дважды в день. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Европейский вложенный домен модели ICON DWD с разрешением 7 км, охватывающий Европу и Северную Атлантику. Среднесрочные прогнозы обновляются четыре раза в день. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Открытая служба прогноза погоды Норвежского метеорологического института, сочетающая высокоразрешающие скандинавские модели с данными ECMWF для предоставления глобальных прогнозов на срок до 10 дней.",
  "forecastModels.description_MF_AROME_ANTILLES": "Вложенный домен AROME над французскими Антильскими островами (Гваделупа, Мартиника) с разрешением 2,5 км. Краткосрочные прогнозы обновляются четыре раза в день.",
  "forecastModels.description_MF_AROME_GUYANE": "Вложенный домен AROME над Французской Гвианой с разрешением 2,5 км. Краткосрочные прогнозы обновляются четыре раза в день.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Вложенный домен AROME над Новой Каледонией с разрешением 2,5 км. Краткосрочные прогнозы обновляются четыре раза в день.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Вложенный домен AROME над Французской Полинезией с разрешением 2,5 км. Краткосрочные прогнозы обновляются четыре раза в день.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Вложенный домен AROME над Реюньоном и Майоттой с разрешением 2,5 км. Краткосрочные прогнозы обновляются четыре раза в день.",
  "forecastModels.description_RRFS_CONUS": "Система Rapid Refresh Forecast NOAA над континентальными США с разрешением 3 км. Почасовые прогнозы обновляются восемь раз в сутки: до 84 часов в четырёх основных прогонах и до 18 часов в остальных.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "Система Rapid Refresh Forecast NOAA, охватывающая всю Северную Америку с разрешением 13 км. Почасовые прогнозы до 84 часов, обновляются четыре раза в сутки.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Флагманский прогноз SmartMixin. Для каждого часа в вашем местоположении мы выбираем лучшую доступную модель — обычно высокоразрешающую региональную модель там, где она существует (AROME во Франции, ICON-D2 в Германии, HRRR в США, ARPEGE Europe по всему континенту…) и возвращаемся к глобальной модели в других местах — затем заполняем любые пробелы из соседних источников. Результат — единый бесшовный прогноз, охватывающий любую точку мира на срок до 14 дней, автоматически обновляемый каждый раз, когда обновляется любая из основополагающих моделей.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Собственный глобальный прогноз Weatherflow, объединяющий несколько численных моделей погоды с наблюдениями его сети метеостанций Tempest. Глобальный горизонт 10 дней.",
  "forecastModels.everywhereElse": "Во всех остальных местах",
  "forecastModels.everywhereElseFoot": "Используется на каждой станции, до которой не дотягиваются предпочитаемые модели.",
  "forecastModels.everywhereElsePick": "Выберите одну",
  "forecastModels.fallbackBlend": "Смесь SmartMixin",
  "forecastModels.fallbackBlendSub": "Объединяет несколько моделей, каждую там, где она сильнее всего.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES везде, куда он дотягивается.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "Глобальная модель NOAA. То, что сегодня используют все аккаунты.",
  "forecastModels.fallbackResolution": "Наивысшее разрешение",
  "forecastModels.fallbackResolutionSub": "Самая мелкая сетка на каждой станции, но у GDPS приоритет ниже, чем у ECMWF и GFS.",
  "forecastModels.forecastChipLabelWithRun": "{model}, расчёт {run}",
  "forecastModels.forecastChipRunHint": "Нажмите и удерживайте, чтобы показать или скрыть последний расчёт",
  "forecastModels.forecastComparisonDescription": "Легко сравнивайте результаты прогнозных моделей из нескольких источников",
  "forecastModels.forecastFollowingPreferences": "По вашим настройкам",
  "forecastModels.forecastLoadError": "Не удалось загрузить прогноз",
  "forecastModels.forecastModel": "Модель прогноза",
  "forecastModels.forecastModelAbout": "О модели {model}",
  "forecastModels.forecastModelComparison": "Сравнение прогнозных моделей",
  "forecastModels.forecastModelCoverage": "Охват",
  "forecastModels.forecastModelDescription": "Описание",
  "forecastModels.forecastModels": "Модели прогноза",
  "forecastModels.forecastModelScopeGlobal": "Глобальная",
  "forecastModels.forecastModelScopeGlobalDescription": "Эта модель охватывает всю планету.",
  "forecastModels.forecastModelScopeRegional": "Региональная",
  "forecastModels.forecastModelScopeRegionalDescription": "Эта модель охватывает только определенный регион.",
  "forecastModels.forecastModelSpecifications": "Характеристики",
  "forecastModels.forecastNoPinLocation": "Ни одна предпочитаемая модель не достаёт до этого расположения — решает «во всех остальных местах».",
  "forecastModels.forecastNoPinStation": "Ни одна предпочитаемая модель не достаёт до этой станции — решает «во всех остальных местах».",
  "forecastModels.forecastNoPreferredModels": "Предпочитаемые модели ещё не заданы.",
  "forecastModels.forecastOverrideElsewhere": "Ваши настройки действуют во всех остальных местах.",
  "forecastModels.forecastPickForLocation": "Или выберите одну для этого расположения",
  "forecastModels.forecastPickForStation": "Или выберите одну для этой станции",
  "forecastModels.forecastPinWinsLocation": "{model} — первая предпочитаемая модель, которая достаёт до этого расположения.",
  "forecastModels.forecastPinWinsStation": "{model} — первая предпочитаемая модель, которая достаёт до этой станции.",
  "forecastModels.forecastServedNowHere": "Сейчас здесь это {model}",
  "forecastModels.forecastSetForLocation": "Задано для этого расположения",
  "forecastModels.forecastSetForStation": "Задано для этой станции",
  "forecastModels.forecastSettingsRowSub": "Предпочитаемые модели и что действует во всех остальных местах",
  "forecastModels.forecastStopUsingHere": "Не использовать здесь",
  "forecastModels.forecastUseForLocation": "Использовать {model} для этого расположения",
  "forecastModels.forecastUseForStation": "Использовать {model} для этой станции",
  "forecastModels.forecastUsePreferred": "Использовать мои предпочитаемые модели",
  "forecastModels.frequencyHourly": "Каждый час",
  "forecastModels.horizon": "Горизонт",
  "forecastModels.horizonValue": "до {value} ч",
  "forecastModels.meshSize": "Размер сетки",
  "forecastModels.pickerShowAll": "Показать весь каталог",
  "forecastModels.pickerUnreachable": "{count, plural, one {Ещё # модель не достаёт} few {Ещё # модели не достают} many {Ещё # моделей не достают} other {Ещё # моделей не достают}} ни до одной из ваших станций",
  "forecastModels.pinInUse": "Используется",
  "forecastModels.pinShadowed": "Никогда не используется — модель выше покрывает все ваши станции",
  "forecastModels.pinSlots": "{used} из {max} · выберите модель",
  "forecastModels.pinSlotsFull": "{max, plural, =1 {Единственный слот занят. Удалите его модель, чтобы добавить другую.} one {Все # слот заняты. Удалите один, чтобы добавить другой.} few {Все # слота заняты. Удалите один, чтобы добавить другой.} many {Все # слотов заняты. Удалите один, чтобы добавить другой.} other {Все # слота заняты. Удалите один, чтобы добавить другой.}}",
  "forecastModels.pinsUncoveredCount": "{used} из ваших {count, plural, one {# станции} few {# станций} many {# станций} other {# станций}}: ни одна предпочитаемая модель до {used, plural, =1 {неё} other {них}} не достаёт — решает «во всех остальных местах».",
  "forecastModels.pinsUncoveredNamed": "{stations}: ни одна предпочитаемая модель до {count, plural, one {неё} other {них}} не достаёт — решает «во всех остальных местах».",
  "forecastModels.pinUnreachable": "Никогда не используется — не достаёт ни до одной из ваших станций",
  "forecastModels.pinUsedAt": "Используется на {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, =1 {Используется на вашей станции} other {Используется на всех станциях (#)}}",
  "forecastModels.pinUsedAtSome": "Используется на {used} из {count, plural, one {# станции} few {# станций} many {# станций} other {# станций}}",
  "forecastModels.preferredModels": "Предпочитаемые модели",
  "forecastModels.preferredModelsAll": "Один список, все станции",
  "forecastModels.preferredModelsOne": "Один список, действует везде",
  "forecastModels.publisher": "Разработчик",
  "forecastModels.removePreferredModel": "Убрать {model} из предпочитаемых моделей",
  "forecastModels.resetForecastPreference": "Сбросить",
  "forecastModels.resetForecastPreferenceHint": "Удаляет предпочитаемые модели и возвращает настройку SmartMixin по умолчанию.",
  "forecastModels.servedNowMany": "Сейчас: GFS {count, plural, =1 {на вашей станции} other {на всех ваших станциях (#)}}.",
  "forecastModels.servedNowNone": "Сейчас: GFS везде.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin мультимодель",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Прогноз Weatherflow",
  "forecastModels.weatherForecastModels": "Модели прогноза погоды",
  "helpCenter.articleCount": "{count, plural, one {# статья} few {# статьи} many {# статей} other {# статей}}",
  "helpCenter.articleNotFound": "Статья не найдена",
  "helpCenter.articleNotFoundDescription": "Статья, которую вы ищете, не существует.",
  "helpCenter.backToHelpCenter": "Вернуться в центр помощи",
  "helpCenter.browseByCategory": "Просмотр по категориям",
  "helpCenter.categoryNotFound": "Категория не найдена",
  "helpCenter.categoryNotFoundDescription": "Эта категория не существует или не содержит статей.",
  "helpCenter.contactSupport": "Связаться с поддержкой",
  "helpCenter.feedbackHelpsImprove": "Ваши отзывы помогают нам улучшать наши справочные статьи.",
  "helpCenter.feedbackReasonNotAnswer": "Не отвечает на мой вопрос",
  "helpCenter.feedbackReasonOutdated": "Информация устарела",
  "helpCenter.feedbackReasonUnclear": "Инструкции непонятны",
  "helpCenter.feedbackWhatWentWrong": "В чём была проблема?",
  "helpCenter.helpCategoryAccount": "Аккаунт",
  "helpCenter.helpCategoryBilling": "Оплата",
  "helpCenter.helpCategoryForecast": "Прогнозы",
  "helpCenter.helpCategoryGettingStarted": "Начало работы",
  "helpCenter.helpCategoryProviders": "Провайдеры",
  "helpCenter.helpCategoryStations": "Станции",
  "helpCenter.helpCategoryTroubleshooting": "Устранение неполадок",
  "helpCenter.helpCenter": "Центр помощи",
  "helpCenter.landingDescription": "Найдите ответы на часто задаваемые вопросы и узнайте, как максимально эффективно использовать SmartMixin.",
  "helpCenter.linkToSection": "Ссылка на этот раздел",
  "helpCenter.menuItemDescription": "Часто задаваемые вопросы и руководства",
  "helpCenter.minRead": "{minutes} мин чтения",
  "helpCenter.onThisPage": "На этой странице",
  "helpCenter.platformMobileApp": "Мобильное приложение",
  "helpCenter.platformMobileOnly": "Только в мобильном приложении",
  "helpCenter.platformWebApp": "Веб-приложение",
  "helpCenter.platformWebOnly": "Только в веб-приложении",
  "helpCenter.popularArticles": "Популярные статьи",
  "helpCenter.relatedArticles": "Связанные статьи",
  "helpCenter.searchArticles": "Поиск статей...",
  "helpCenter.stillNeedHelp": "Всё ещё нужна помощь?",
  "helpCenter.stillNeedHelpDescription": "Если эта статья не ответила на ваш вопрос, я с радостью помогу вам напрямую.",
  "helpCenter.supportEmailSubject": "Помощь SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Помощь SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "Спасибо за ваш отзыв!",
  "helpCenter.wasArticleHelpful": "Была ли эта статья полезной?",
  "intro.allowLocation": "Разрешить геолокацию",
  "intro.alreadyHaveAccount": "Уже есть аккаунт?",
  "intro.connectStationDescription": "Выберите свой сервис. Для подключения нужно будет войти в аккаунт.",
  "intro.connectStationTitle": "Подключите свою станцию",
  "intro.haveWeatherStation": "У меня есть метеостанция",
  "intro.locationDescription": "Разрешите доступ к местоположению, чтобы получать точные прогнозы, адаптированные к вашему району — без универсальных прогнозов.",
  "intro.locationTitle": "Прогнозы, созданные для вас",
  "intro.showWeatherHere": "Показать погоду там, где я",
  "intro.showWeatherInstead": "Не сейчас, покажите погоду",
  "intro.welcomeDescription": "Получайте гиперлокальные прогнозы от лучших метеорологических агентств — плюс доступ к более чем 40 000 метеостанциям по всему миру, чтобы видеть реальные условия, прошлые и настоящие.",
  "intro.welcomeTitle": "Ваш прогноз погоды, заново переосмыслен",
  "landing.alsoAvailableOn": "Также доступно на:",
  "landing.featureAlertsDescription": "Задавайте собственные пороги для любого показателя. Получайте уведомления, когда падает температура, начинается дождь или усиливается ветер.",
  "landing.featureAlertsTitle": "Умные оповещения",
  "landing.featureAnalyticsDescription": "Интерактивные графики, анализ трендов и подробная статистика. Погрузитесь в данные о температуре, влажности, давлении, дожде и ветре.",
  "landing.featureAnalyticsTitle": "Расширенная аналитика",
  "landing.featureExportDescription": "Получайте все свои погодные данные по электронной почте в виде таблицы Excel, готовой для дальнейшего анализа в Excel, Google Таблицах или любимых инструментах.",
  "landing.featureExportTitle": "Экспортируйте свои данные",
  "landing.featureForecastDescription": "Доступ к {count, plural, one {#+ профессиональной модели прогноза} few {#+ профессиональным моделям прогноза} many {#+ профессиональным моделям прогноза} other {#+ профессиональным моделям прогноза}}, включая ECMWF, GFS и региональные модели. Сравнивайте их бок о бок и делайте собственные прогнозы.",
  "landing.featureForecastTitle": "Сравнивайте модели прогноза",
  "landing.featureHistoryDescription": "Доступ к историческим данным с почасовой, дневной и месячной шкалой. Экспортируйте их в Excel для исследований или личных архивов.",
  "landing.featureHistoryTitle": "Богатая история",
  "landing.featureMultiBrandDescription": "Подключайте Netatmo, Davis, Tempest, Ecowitt, Ambient Weather и другие. Больше не нужно переключаться между приложениями.",
  "landing.featureMultiBrandTitle": "Все бренды в одном приложении",
  "landing.featuresSubtitle": "SmartMixin даёт вам инструменты, чтобы анализировать, сравнивать и понимать свои погодные данные как профессионал.",
  "landing.featuresTitle": "Создано для любителей данных",
  "landing.finalCtaButton": "Создать бесплатный аккаунт",
  "landing.finalCtaSubtitle": "Присоединяйтесь к тысячам энтузиастов погоды, которые доверяют SmartMixin.",
  "landing.finalCtaTitle": "Готовы глубже погрузиться в свои погодные данные?",
  "landing.heroCta": "Начать бесплатно",
  "landing.heroDescription": "Глубокая аналитика, красивые графики и профессиональные прогнозы — все ваши метеостанции в одном мощном приложении.",
  "landing.heroSecondaryCta": "Исследовать карту",
  "landing.heroTagline": "Для любителей погоды",
  "landing.heroTitle": "Смотрите на свою погоду как никогда раньше",
  "landing.pricingComparisonCaption": "Сравнение функций бесплатного плана и Premium",
  "landing.pricingFeatureAdvancedMetrics": "Продвинутые метрики",
  "landing.pricingFeatureAlerts": "Пользовательские оповещения",
  "landing.pricingFeatureColumn": "Функция",
  "landing.pricingFeatureExport": "Экспорт данных (Excel)",
  "landing.pricingFeatureForecastComparison": "Сравнение прогнозов",
  "landing.pricingFeatureForecasts": "Модели прогноза",
  "landing.pricingFeatureForecastsFreeTier": "1 модель",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ модель} few {#+ модели} many {#+ моделей} other {#+ модели}}",
  "landing.pricingFeatureReports": "Анализ и отчёты",
  "landing.pricingFeatureStationComparison": "Сравнение станций",
  "landing.pricingFeatureWidgets": "Виджеты главного экрана",
  "landing.pricingFeatureYearOverYear": "Анализ год к году",
  "landing.pricingFreeCta": "Начать",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Самый популярный",
  "landing.pricingPremiumCta": "Начать",
  "landing.pricingPremiumDescription": "От 1,99 €/месяц — подпишитесь на сайте, в App Store или Google Play",
  "landing.pricingSubtitle": "Начните бесплатно, перейдите на платную версию, когда понадобится больше.",
  "landing.pricingTitle": "Простые, прозрачные цены",
  "landing.statBrands": "Поддерживаемых брендов",
  "landing.statForecasts": "Моделей прогноза",
  "landing.statStations": "Метеостанций",
  "landing.supportedDevicesNote": "Плюс более {count, number} общедоступных станций из сети Всемирной метеорологической организации",
  "landing.supportedDevicesSubtitle": "Подключите свою метеостанцию за считанные минуты. Мы поддерживаем {count, plural, one {# крупный бренд} few {# крупных бренда} many {# крупных брендов} other {# крупного бренда}}, и их число растёт.",
  "landing.supportedDevicesTitle": "Работает с вашей станцией",
  "metrics.absolutePressure": "Абсолютное давление",
  "metrics.airDensity": "Плотность воздуха",
  "metrics.airGap": "Воздушный зазор",
  "metrics.apparentTemperature": "Ощущаемая температура",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Среднее",
  "metrics.avg_wind": "Средний ветер",
  "metrics.beaufort": "Бофорт",
  "metrics.blackGlobeTemperature": "Темп. чёрного шара",
  "metrics.boilerOn": "Котел ВКЛ.",
  "metrics.boilerOnInHours": "Котел ВКЛ. (часы)",
  "metrics.cloudCover": "Облачность",
  "metrics.co2": "СО2",
  "metrics.conductivity": "Проводимость",
  "metrics.dailyPrecipitation": "Суточные осадки",
  "metrics.dailyRain": "Суточные осадки",
  "metrics.degreeDayShort": "ДД",
  "metrics.depth": "Глубина",
  "metrics.depthSensors": "Датчики глубины",
  "metrics.dewPoint": "Точка росы",
  "metrics.distance": "Расстояние",
  "metrics.downTrend": "вниз",
  "metrics.ET": "Эвапотранспирация",
  "metrics.etToday": "Эвапотранспирация сегодня",
  "metrics.feelsLike": "Ощущается как",
  "metrics.feelsLikeWithFormula": "Ощущается как ({formula})",
  "metrics.frostPoint": "Точка инея",
  "metrics.gust": "Порыв",
  "metrics.gustDirection": "Направление порыва",
  "metrics.hail": "Град",
  "metrics.heatIndex": "Индекс тепла",
  "metrics.heatingDegreeDays": "Градус-дни отопления",
  "metrics.heatingPower": "Мощность нагрева",
  "metrics.humidex": "Гумидекс",
  "metrics.humidity": "Влажность",
  "metrics.lastLightningImpact": "Последний удар",
  "metrics.lastMeasure": "Последнее измерение",
  "metrics.leafSensors": "Датчики листьев",
  "metrics.leafWetness": "Влажность листьев",
  "metrics.lightningDistance": "Расстояние",
  "metrics.lightningStrikeCount": "Количество ударов молнии",
  "metrics.lightningStrikeDistance": "Расстояние удара молнии",
  "metrics.max": "Макс.",
  "metrics.max_gust": "Макс. порыв",
  "metrics.maxToday": "Макс. сегодня",
  "metrics.min": "Мин.",
  "metrics.noise": "Шум",
  "metrics.normalizedHeatingCoefficient": "Нормированный коэффициент нагрева",
  "metrics.outdoorTemperature": "Температура наружного воздуха",
  "metrics.PM_1": "ТЧ1",
  "metrics.PM_10": "ТЧ10",
  "metrics.PM_2P5": "ТЧ2,5",
  "metrics.precipitation": "Атмосферные осадки",
  "metrics.pressure": "Давление",
  "metrics.rain": "Дождь",
  "metrics.rainDurationValue": "Продолжительность дождя: {duration}",
  "metrics.rainRate": "Интенсивность дождя",
  "metrics.relativePressure": "Относительное давление",
  "metrics.setPoint": "Уставка",
  "metrics.snow": "Снег",
  "metrics.snowfall": "Снегопад",
  "metrics.soilMoisture": "Влага",
  "metrics.soilSensors": "Датчики почвы",
  "metrics.soilWaterTension": "Натяжение почвенной влаги",
  "metrics.solarEnergy": "Солнечная энергия",
  "metrics.solarRadiation": "Солнечная радиация",
  "metrics.speed": "Скорость",
  "metrics.stableTrend": "стабильный",
  "metrics.sum": "Сумма",
  "metrics.temperature": "Температура",
  "metrics.temperatureSensors": "Датчики температуры и влажности",
  "metrics.temperatureShort": "Темп.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "вверх",
  "metrics.uv": "УФ",
  "metrics.visibility": "Видимость",
  "metrics.weatherCondition": "Погодные условия",
  "metrics.wetBulbGlobeTemperature": "Темп. влажного шара",
  "metrics.wetBulbTemperature": "Температура влажного термометра",
  "metrics.wind": "Ветер",
  "metrics.windChill": "Ветро-холодовой индекс",
  "metrics.windDirection": "Направление ветра",
  "metrics.windRun": "Ветровой пробег",
  "metrics.windRunDescription": "Ветровой пробег — это общее расстояние, пройденное ветром за определённый период времени",
  "metrics.windSpeed": "Скорость ветра",
  "navigation.allFavorites": "Показать все",
  "navigation.breadcrumbs": "Навигационная цепочка",
  "navigation.collapseNavigation": "Свернуть навигацию",
  "navigation.expandNavigation": "Развернуть навигацию",
  "navigation.main": "Основная",
  "navigation.mapShort": "Карта",
  "navigation.skipToContent": "Перейти к основному содержанию",
  "network.cancelError": "Запрос отменен",
  "network.connectionError": "Сервер недоступен",
  "network.networkError": "Сеть недоступна",
  "network.serverError": "Что-то пошло не так...",
  "network.timeoutError": "Время соединения вышло",
  "network.tooManyRequests": "Слишком много запросов. Повторите попытку позже.",
  "network.unknownError": "Неизвестная ошибка",
  "premium.alreadyPremium": "У вас уже есть премиум-аккаунт!",
  "premium.bestValue": "Лучшее предложение",
  "premium.billingDetailsAndroid": "Бесплатный пробный период: плата не взимается, если вы отмените подписку не менее чем за 24 часа до его окончания. Затем подписка SmartMixin продлевается автоматически, если вы не отмените её не менее чем за 24 часа до окончания текущего периода; отменить её можно в любой момент в настройках учётной записи Google Play. Каждое продление оплачивается по цене, указанной на кнопке выше. Оплата списывается с вашей учётной записи Google Play при подтверждении покупки и в начале каждого периода продления.",
  "premium.billingDetailsIos": "Бесплатный пробный период: плата не взимается, если вы отмените подписку не менее чем за 24 часа до его окончания. Затем подписка SmartMixin продлевается автоматически, если вы не отмените её не менее чем за 24 часа до окончания текущего периода; отменить её можно в любой момент в настройках учётной записи App Store. Каждое продление оплачивается по цене, указанной на кнопке выше. Оплата списывается с вашей учётной записи App Store при подтверждении покупки и в начале каждого периода продления.",
  "premium.freeBannerBody": "Без Premium вы получаете GFS везде — ваши предпочитаемые модели и «во всех остальных местах» начнут работать сразу после оформления подписки.",
  "premium.freeBannerTitle": "Настройки действуют с Premium",
  "premium.freeSubscription": "Бесплатная премиум-подписка",
  "premium.freeTrialForPeriod": "Бесплатный пробный период: {period, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
  "premium.getUnlimitedAccess": "Неограниченный доступ к:",
  "premium.manageMySubscription": "Управлять моей подпиской",
  "premium.notPurchasedYet": "Для этой учётной записи магазина не найдено покупок SmartMixin Premium.",
  "premium.orChooseMonthly": "Или выберите ежемесячно:",
  "premium.plansRetry": "Повторить",
  "premium.plansUnavailable": "Не удалось загрузить варианты подписки. Проверьте подключение к интернету и попробуйте снова.",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Активна",
  "premium.premiumAnnualTrialInfo": "Начните с бесплатного пробного периода на {days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
  "premium.premiumCurrentPlan": "Текущий план",
  "premium.premiumDownloadApp": "Загрузите приложение для подписки:",
  "premium.premiumEndsOn": "Истекает {date}",
  "premium.premiumFeatureAlerts": "Погодные оповещения",
  "premium.premiumFeatureAnalysis": "Расширенный анализ погоды",
  "premium.premiumFeatureCharts": "Сравнение графиков",
  "premium.premiumFeatureExport": "Экспорт данных",
  "premium.premiumFeatureForecast": "Региональные модели прогнозов",
  "premium.premiumFeatureNotification": "Виджет строки состояния",
  "premium.premiumFeatureTitle": "Функция Premium",
  "premium.premiumFeatureWidgets": "Виджеты главного экрана",
  "premium.premiumFreePlan": "Бесплатный",
  "premium.premiumInactive": "Нет подписки",
  "premium.premiumManageStoreSubscription": "Вы оформили подписку через {store}. Управлять ею или отменить её можно там.",
  "premium.premiumManageWebSubscription": "Управляйте подпиской, обновите способ оплаты или отмените.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Продление {date}",
  "premium.premiumSubscribeAnnual": "Ежегодно — 9,99 €/год",
  "premium.premiumSubscribedOn": "Подписка через {platform}",
  "premium.premiumSubscribedOnWeb": "Подписка оформлена на сайте",
  "premium.premiumSubscribeMonthly": "Ежемесячно — 1,99 €/месяц",
  "premium.premiumSubscribeOnWeb": "Подпишитесь сейчас, чтобы разблокировать все премиум-функции.",
  "premium.premiumSubscriptionSuccess": "Ваша подписка активирована! Наслаждайтесь всеми премиум-функциями.",
  "premium.premiumSubscriptionSuccessTitle": "Добро пожаловать в Premium!",
  "premium.premiumWebappNotice": "Оформить подписку на сайте сейчас нельзя.",
  "premium.pricePerMonth": "{price}/месяц",
  "premium.pricePerYear": "{price}/год",
  "premium.purchasedNetatmoPro": "Ранее вы приобрели Netatmo Pro ({date}). Это дает вам доступ к набору премиум-функций. Подпишитесь на одно из следующих предложений, если хотите получить доступ ко всем премиум-функциям.",
  "premium.purchaseFailed": "Не удалось завершить покупку. Попробуйте ещё раз.",
  "premium.restoreFailed": "Не удалось восстановить покупки. Попробуйте ещё раз.",
  "premium.restorePurchase": "Восстановить покупку",
  "premium.savingsPercent": "Экономия {percent}%",
  "premium.seePremium": "Узнать о Premium",
  "premium.startFreeTrial": "Начать бесплатную пробную версию",
  "premium.storeUnavailable": "Магазин сейчас недоступен. Попробуйте позже.",
  "premium.subscribeNow": "Подписаться сейчас — без пробного периода",
  "premium.switchToPremium": "Перейти на SmartMixin Premium",
  "premium.thenPrice": "затем {price}",
  "providerHints.ambientWeatherApiKey": "Создаётся в настройках вашей учётной записи на ambientweather.net.",
  "providerHints.davisApiSecret": "Показывается только один раз при создании ключа V2 API — храните в надёжном месте.",
  "providerHints.davisV2ApiKey": "Со страницы ключей V2 API на weatherlink.com.",
  "providerHints.ecowittApi": "Со страницы API вашей учётной записи Ecowitt.",
  "providerHints.ecowittApp": "Ключ приложения, также из вашей учётной записи Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Используйте email и пароль учётной записи My AcuRite — не вход в SmartMixin.",
  "providerHints.myAcuriteEmail": "Электронная почта вашей учётной записи My AcuRite — не ваш вход в SmartMixin.",
  "providerHints.myAcuritePassword": "Пароль вашей учётной записи My AcuRite.",
  "providerHints.weatherflowToken": "Персональный токен из tempestwx.com → настройки → авторизации данных.",
  "providerHints.wundergroundEditKey": "Использовать другой ключ",
  "providerHints.wundergroundKey": "Длинная строка со страницы API-ключей вашей учётной записи Weather Underground — не ваш пароль на wunderground.com.",
  "providerHints.wundergroundKeyExample": "напр. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-ключ подтверждён",
  "providerHints.wundergroundNoStationsNearby": "Поблизости от этого места не найдено станций. Попробуйте ввести ID станции напрямую.",
  "providerHints.wundergroundStationIdExample": "напр. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Получите свой API-ключ Ambient Weather.",
  "providerIntro.davisStep2": "Получите свой ключ V2 API и API-секрет Davis.",
  "providerIntro.ecowittStep2": "Получите свой API-ключ и ключ приложения Ecowitt.",
  "providerIntro.getStarted": "Начать",
  "providerIntro.myAcuriteStep2": "Используйте email и пароль вашей существующей учётной записи My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Войдите в Netatmo, когда появится запрос — API-ключ не требуется.",
  "providerIntro.netatmoWeatherStep2": "Войдите в Netatmo, когда появится запрос — API-ключ не требуется.",
  "providerIntro.signupBanner": "Почти готово — создайте бесплатную учётную запись SmartMixin, чтобы подключить {provider}.",
  "providerIntro.step1": "Войдите в свою учётную запись SmartMixin (НЕ в {provider}).",
  "providerIntro.step3EmailPassword": "Введите их здесь.",
  "providerIntro.step3KeyOrToken": "Вставьте сюда.",
  "providerIntro.step3OAuth": "Авторизуйте SmartMixin во всплывающем окне.",
  "providerIntro.step3Wunderground": "Вставьте ваш API-ключ, затем выберите ближайшую станцию или введите любой ID станции.",
  "providerIntro.stepOfTotal": "Шаг {step} из {total}",
  "providerIntro.title": "Подключить {provider}",
  "providerIntro.weatherflowStep2": "Получите свой персональный токен Tempest.",
  "providerIntro.wundergroundBrowsePublic": "Нет станции? Просмотрите публичные",
  "providerIntro.wundergroundFindNearby": "Найти станции поблизости",
  "providerIntro.wundergroundOrEnterId": "Или введите ID станции",
  "providerIntro.wundergroundStep2": "Получите свой API-ключ Weather Underground. Затем вы сможете подключить любую станцию — свою или публичную.",
  "reports.agroMeteorology": "Агрометеорология",
  "reports.analysis": "Анализ",
  "reports.annualCumulativeRainfallComparison": "Ежегодное сравнение совокупного количества осадков",
  "reports.annualHeatingDurationComparison": "Сравнение годовой продолжительности отопления",
  "reports.annualHeatingEfficiency": "Годовая эффективность отопления",
  "reports.annualIndoorComparison": "Ежегодное сравнение внутри помещений",
  "reports.annualOutdoorComparison": "Ежегодное сравнение на открытом воздухе",
  "reports.annualOutdoorReport": "Годовой отчет о наружных измерениях",
  "reports.annualReport": "Годовой отчет",
  "reports.annualSolarReport": "Ежегодный солнечный отчет",
  "reports.annualWaterBalance": "Годовой водный баланс",
  "reports.annualWaterBalanceCarryOver": "Перенести с {year} года ({value})",
  "reports.annualWaterBalanceDescription": "Водный баланс (упрощенная версия, используются только дождь и суммарное испарение) помогает управлять водоснабжением.",
  "reports.avgHumidity": "Средняя влажность",
  "reports.avgMaxTemperature": "Средняя Т°макс.",
  "reports.avgMetric": "Среднее – {metric}",
  "reports.avgMinTemperature": "Средняя Т°мин",
  "reports.avgPressure": "Среднее давление",
  "reports.avgTemperature": "Средняя температура",
  "reports.chartsAndTable": "Графики и таблица",
  "reports.climateNormalPeriodOfRecord": "Период наблюдений ({years, plural, one {# год} few {# года} many {# лет} other {# года}})",
  "reports.climateNormals": "Климатические нормы",
  "reports.climateNormalStandardLabel": "Стандартная норма ({period})",
  "reports.climateTrendPerDecade": "Тренд температуры: {value} за десятилетие (данные за {years, plural, one {# год} few {# года} many {# лет} other {# года}})",
  "reports.coldestMonthRanking": "Самый холодный {month} за историю наблюдений",
  "reports.comfortable": "Комфортный (45 % {lessThan} влажность ≤ 60 %)",
  "reports.coverageAllDays": "{total, plural, one {# день} few {Все # дня} many {Все # дней} other {Все # дня}}",
  "reports.coverageMetricsCount": "{metrics}: {count} из {total, plural, one {# дня} few {# дней} many {# дней} other {# дня}}",
  "reports.coverageMetricsEveryDay": "{metrics}: каждый день",
  "reports.coverageMonthToDate": "С начала месяца",
  "reports.coverageNoReadings": "Нет измерений: {dates}",
  "reports.coverageReadingsCount": "Измерения за {count} из {total, plural, one {# дня} few {# дней} many {# дней} other {# дня}}",
  "reports.coverageTodayUntil": "Сегодня до {time}",
  "reports.coverageYearToDate": "С начала года",
  "reports.cumulativeRainfall": "Накопленные осадки",
  "reports.cumulativeRainfallDescription": "Отслеживайте общее количество осадков, накопившихся за выбранный период.",
  "reports.dailyMaxRainfall": "Макс. суточные осадки",
  "reports.dataExport": "Экспорт данных",
  "reports.dataExportXlsxFormatDescription": "Экспортируйте все данные вашей станции в формате Excel (*.xlsx). После того, как вы нажмете кнопку, через несколько минут вы получите электронное письмо с обработанными данными.",
  "reports.daysOfData": "{days, plural, one {# день} few {# дня} many {# дней} other {# дня}} данных",
  "reports.daysWithFrost": "Дни с морозом",
  "reports.daysWithHeavyRain": "Дни с сильным дождём (≥ {threshold})",
  "reports.daysWithoutThaw": "Дни без оттепели",
  "reports.daysWithStrongFrost": "Дни с сильными морозами",
  "reports.emailSent": "На ваш почтовый ящик было отправлено письмо",
  "reports.frostDays": "Морозные дни",
  "reports.grasslandTemperatureSum": "Сумма температур пастбищ",
  "reports.grasslandTemperatureSumDescription": "Если сумма {threshold} превышена весной, устойчивое начало вегетации достигнуто (работает в Европе)",
  "reports.grasslandThresholdLabel": "Начало вегетации: {threshold}",
  "reports.growingDegreeDays": "Градусо-дни роста",
  "reports.highPressure": "Антициклон (среднее давление ≥ {threshold})",
  "reports.historyImportInProgress": "Более ранняя история вашей станции ещё импортируется. В ближайшие несколько дней появятся данные за прошлые годы.",
  "reports.iceDays": "Дни без оттепели",
  "reports.indoorReport": "Внутренний отчет",
  "reports.keyFacts": "Ключевые факты",
  "reports.longestDrySpell": "Макс. период без осадков",
  "reports.longestRunOfRainyDays": "Самая длинная серия дождливых дней",
  "reports.longestRunWithoutRun": "Самый длинный период без дождя",
  "reports.longestWetSpell": "Макс. период с осадками",
  "reports.lowPressure": "Низкое давление (среднее давление {lessThan} {threshold})",
  "reports.maxHumidity": "Максимальная влажность",
  "reports.maxMetric": "Максимум – {metric}",
  "reports.maxPressure": "Максимальное давление",
  "reports.maxTemperature": "Максимальная температура",
  "reports.maxTempGreaterThan": "Т°макс ≥",
  "reports.maxTempMagnitude24h": "Максимальная амплитуда (/24 ч)",
  "reports.minHumidity": "Минимальная влажность",
  "reports.minMetric": "Минимум – {metric}",
  "reports.minPressure": "Минимальное давление",
  "reports.minTemperature": "Минимальная температура",
  "reports.minTempMagnitude24h": "Минимальная амплитуда (/24 ч)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Ещё # день} few {Ещё # дня} many {Ещё # дней} other {Ещё # дня}} в этом месяце",
  "reports.monthlyAverageCountdownDetail": "Тогда появятся среднее за месяц и его рейтинг.",
  "reports.monthlyAverageRule": "Средние за месяц и рейтинги появятся, когда в календарном месяце будет записано {days, plural, one {# день} few {# дня} many {# дней} other {# дня}}.",
  "reports.monthlyHeatingEfficiency": "Ежемесячная эффективность отопления",
  "reports.monthlyOutdoorReport": "Ежемесячный отчет о наружных измерениях",
  "reports.monthlyReport": "Ежемесячный отчет",
  "reports.monthlySolarReport": "Ежемесячный отчет о солнечной энергии",
  "reports.monthlyWindReport": "Ежемесячный отчет о ветре",
  "reports.monthsOfData": "{months, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}} данных",
  "reports.noReadings": "Нет измерений",
  "reports.numberOfDays": "Количество дней",
  "reports.onThisDayChartRule": "График по годам появится, когда для {date} будет записано {count, plural, one {# год} few {# года} many {# лет} other {# года}}.",
  "reports.onThisDayChartSummary": "{years, plural, one {# год} few {# года} many {# лет} other {# года}} с температурой, с {first} по {last}. Рекорд тепла {high} в {highYears}, рекорд холода {low} в {lowYear}. Обычный день от {min} до {max}.",
  "reports.onThisDayChartSummaryNoNormal": "{years, plural, one {# год} few {# года} many {# лет} other {# года}} с температурой, с {first} по {last}. Рекорд тепла {high} в {highYears}, рекорд холода {low} в {lowYear}.",
  "reports.onThisDayCoverage": "{years, plural, one {# год с {firstYear}} few {# года с {firstYear}} many {# лет с {firstYear}} other {# года с {firstYear}}}",
  "reports.onThisDayDataSince": "У этой станции есть данные с {date}.",
  "reports.onThisDayEveryYear": "Каждое {date} в архиве",
  "reports.onThisDayGapNoData": "нет данных",
  "reports.onThisDayHighOnlySummary": "{year}: максимум {max}, дождь {rain}",
  "reports.onThisDayInHistory": "В этот день в истории",
  "reports.onThisDayLeaveOk": "Можно покинуть этот экран — загрузка продолжится.",
  "reports.onThisDayLoadFailed": "Не удалось загрузить {date}. Проверьте подключение и попробуйте ещё раз.",
  "reports.onThisDayLowOnlySummary": "{year}: минимум {min}, дождь {rain}",
  "reports.onThisDayNoDataRun": "{start}–{end} · нет данных ({count, plural, one {# год} few {# года} many {# лет} other {# года}})",
  "reports.onThisDayNormal": "Обычный день: от {min} до {max}",
  "reports.onThisDayNoYears": "Полного дня {date} в архиве пока нет",
  "reports.onThisDayNoYearsDetail": "Страница заполнится начиная с первого {date}, который станция запишет полностью.",
  "reports.onThisDayNoYearSelected": "Год не выбран",
  "reports.onThisDayOneReading": "1 измерение",
  "reports.onThisDayOneReadingSummary": "{year}: {value}, 1 измерение, дождь {rain}",
  "reports.onThisDayOpenRecords": "Открыть «Рекорды и климат»",
  "reports.onThisDayPickHint": "Меняет показанный день",
  "reports.onThisDayPickTitle": "Выберите день",
  "reports.onThisDayRain": "Дождь {date}",
  "reports.onThisDayRainNotMeasured": "не измерялся",
  "reports.onThisDayRainOnlySummary": "{year}: дождь {rain}",
  "reports.onThisDayRainSince": "дождь с {year}",
  "reports.onThisDayRainSummary": "Дождь {date}. Самый дождливый день {value} в {years}.",
  "reports.onThisDayRetry": "Повторить",
  "reports.onThisDaySingleReading": "Годы с одним измерением за этот день ({count}) не показаны на графике.",
  "reports.onThisDaySlowLoad": "Чтение {years, plural, one {# года} few {# лет} many {# лет} other {# года}} для {date}. Первый запрос даты может занять до 20 секунд.",
  "reports.onThisDaySlowLoadGeneric": "Чтение истории этой станции за {date}. Первый запрос даты может занять до 20 секунд.",
  "reports.onThisDayTied": "наравне с {years}",
  "reports.onThisDayTiedMore": "наравне с {years} +{count}",
  "reports.onThisDayYearSummary": "{year}: минимум {min}, максимум {max}, дождь {rain}",
  "reports.onThisDayYearTied": "{year} ({tied})",
  "reports.outdoorReport": "Отчет о наружных измерениях",
  "reports.overviewSection": "Обзор",
  "reports.rainfall": "Осадки",
  "reports.rainyDays": "Дождливые дни",
  "reports.recordCalendarDay": "Календарные сутки (от полуночи до полуночи)",
  "reports.recordClimatologicalDay": "Климатологические сутки (06–06 UTC)",
  "reports.recordClimDayBody": "Самый дождливый день считается двумя способами. Календарные сутки длятся от полуночи до полуночи по времени станции. Климатологические сутки длятся с 06:00 до 06:00 UTC, как их считают метеослужбы. Они могут по-разному разделить одну и ту же грозу, поэтому их суммы могут различаться, а иногда и их даты.",
  "reports.recordDailyRain": "Самый дождливый день",
  "reports.recordFromHourlyReadings": "По ежечасным измерениям",
  "reports.recordHigh": "Рекорд тепла",
  "reports.recordLow": "Рекорд холода",
  "reports.recordOfficialBody": "Метеослужба публикует для этой станции суточные максимум и минимум, снятые с максимального и минимального термометров. Они улавливают короткие пики, которые пропускают ежечасные измерения, поэтому заменяют значения, рассчитанные по ежечасным измерениям.",
  "reports.recordOfficialValue": "Официальное значение",
  "reports.recordsAndClimatology": "Рекорды и климат",
  "reports.recordSheetTitle": "Об этих рекордах",
  "reports.recordsSince": "Рекорды с {date}",
  "reports.recordWindGust": "Сильнейший порыв ветра",
  "reports.relativelyWet": "Относительно влажно (60 % {lessThan} влажность ≤ 80 %)",
  "reports.sectionReportCount": "{count, plural, one {# отчёт} few {# отчёта} many {# отчётов} other {# отчётов}}",
  "reports.sendEmail": "Отправить письмо",
  "reports.summerDays": "Летние дни",
  "reports.tableScrollRegion": "{title}, прокручивается по горизонтали",
  "reports.tooDry": "Слишком сухо (влажность ≤ 45%)",
  "reports.tooWet": "Слишком влажно (влажность {greaterThan} 80%)",
  "reports.tropicalNights": "Тропические ночи",
  "reports.unlockPremiumSubtitle": "Входит в SmartMixin Premium",
  "reports.unlockPremiumTitle": "Откройте {count, plural, one {# премиум-функцию} few {# премиум-функции} many {# премиум-функций} other {# премиум-функций}}",
  "reports.warmestMonthRanking": "Самый тёплый {month} за историю наблюдений",
  "reports.waterBalance": "Водный баланс",
  "reports.yearsOfData": "{years, plural, one {# год} few {# года} many {# лет} other {# года}} данных",
  "reports.yearToDateTemperatureComparison": "Сравнение температуры с начала года",
  "sensors.bgtSensors": "Чёрный шар и WBGT",
  "sensors.cameraFeed": "Камера",
  "sensors.compareHumidity": "Сравнить влажность",
  "sensors.compareMoisture": "Сравнить влажность почвы",
  "sensors.comparePm25": "Сравнить PM2.5",
  "sensors.compareTemperatures": "Сравнить температуры",
  "sensors.compareWaterTension": "Сравнить натяжение почвенной влаги",
  "sensors.depthByChannel": "Глубина по каналу",
  "sensors.heatStressExtreme": "Экстремальный тепловой стресс",
  "sensors.heatStressModerate": "Умеренный тепловой стресс",
  "sensors.heatStressNone": "Нет теплового стресса",
  "sensors.heatStressStrong": "Сильный тепловой стресс",
  "sensors.heatStressVeryStrong": "Очень сильный тепловой стресс",
  "sensors.indoorClimate": "Микроклимат",
  "sensors.indoorCo2Levels": "Уровни CO2",
  "sensors.indoorTemperatureAndHumidity": "Температура и влажность",
  "sensors.leafWetnessByChannel": "Влажность листьев по каналу",
  "sensors.lightningSensor": "Молния",
  "sensors.moistureByChannel": "Влажность почвы по каналу",
  "sensors.noDataAvailable": "Нет данных",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 по каналу",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Выберите канал",
  "sensors.sensorDetailDescription": "Просмотр исторических данных и трендов по каналам датчика.",
  "sensors.sensorHistory": "История датчика",
  "sensors.soilConductivityByChannel": "Проводимость по каналу",
  "sensors.soilTemperatureByChannel": "Температура почвы по каналу",
  "sensors.strikesToday": "Удары сегодня",
  "sensors.temperatureByChannel": "Температура по каналу",
  "sensors.viewChart": "Показать график",
  "sensors.waterTensionByChannel": "Натяжение почвенной влаги по каналу",
  "settings.appearance": "Оформление",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "арабский",
  "settings.bulgarian": "болгарский",
  "settings.catalan": "каталанский",
  "settings.chartGestures": "Жесты на графиках",
  "settings.chartGesturesDescription": "Проведение по графикам меняет период времени, сведение графиков меняет временной масштаб.",
  "settings.choiceCount": "{count, plural, one {Доступен: #} few {Доступно: #} many {Доступно: #} other {Доступно: #}}",
  "settings.contactUs": "Связаться с нами",
  "settings.contactUsDescription": "Получите помощь или отправьте отзыв",
  "settings.croatian": "хорватский",
  "settings.czech": "чешский",
  "settings.dailyDetailByPeriods": "Детали дня по периодам",
  "settings.dailyDetailByPeriodsDescription": "Группировать 24 часа в ночь, утро, день и вечер — то же деление, что и в сводке дня.",
  "settings.danish": "датский",
  "settings.dark": "Темная тема",
  "settings.dataDisplay": "Отображение данных",
  "settings.dateAndTime": "Дата и время",
  "settings.donateButton": "Сделать пожертвование",
  "settings.donateDescription": "SmartMixin создаёт небольшая команда. Если приложение вам полезно, вы можете поддержать его развитие разовым пожертвованием на любую сумму. Это подарок — он не меняет ваш тариф и не открывает никаких функций.",
  "settings.donateSuccessBody": "Ваше пожертвование помогает SmartMixin работать и становиться лучше. Мы искренне это ценим.",
  "settings.donateSuccessTitle": "Спасибо за вашу поддержку!",
  "settings.donateTitle": "Поддержите SmartMixin",
  "settings.dragToReorder": "Перетащите, чтобы изменить порядок",
  "settings.dutch": "голландский",
  "settings.english": "английский",
  "settings.french": "французский",
  "settings.german": "немецкий",
  "settings.gestures": "Жесты",
  "settings.greek": "греческий",
  "settings.hungarian": "венгерский",
  "settings.italian": "итальянский",
  "settings.japanese": "японский",
  "settings.korean": "корейский",
  "settings.language": "Язык",
  "settings.languageDescription": "Предпочтительный язык",
  "settings.light": "Светлая тема",
  "settings.mapTheme": "Тема карты",
  "settings.mapThemeAuto": "Авто",
  "settings.mapThemeDark": "Темная",
  "settings.mapThemeDescription": "В режиме «Авто» карта следует теме приложения.",
  "settings.mapThemeLight": "Светлая",
  "settings.measurementUnits": "Единицы измерения",
  "settings.netatmoDashboard": "Панель Netatmo",
  "settings.netatmoLayoutCards": "Список карточек",
  "settings.netatmoLayoutCardsDescription": "По карточке на модуль, всё одним списком",
  "settings.netatmoLayoutClassic": "Классический",
  "settings.netatmoLayoutClassicDescription": "Две карточки, переключение между модулями",
  "settings.netatmoNewLayoutNotice": "Новый вид панели: по карточке на модуль.",
  "settings.netatmoSwitchBackToClassic": "Вернуть классический",
  "settings.netatmoSwitchToLayout": "Переключить на {layout}",
  "settings.norwegian": "норвежский",
  "settings.notificationsSection": "Уведомления",
  "settings.ongoingNotificationEnabled": "Включить постоянное уведомление",
  "settings.ongoingNotificationMetrics": "Отображаемые показатели",
  "settings.ongoingNotificationPermissionRequired": "Требуется разрешение на уведомления",
  "settings.ongoingNotificationPreviewHint": "Предпросмотр — включите виджет, чтобы он отображался",
  "settings.ongoingNotificationStatusBar": "Строка состояния",
  "settings.polish": "польский",
  "settings.portuguese": "португальский",
  "settings.preferencesSection": "Параметры",
  "settings.privacyPolicy": "Политика конфиденциальности",
  "settings.russian": "русский",
  "settings.serbian": "сербский",
  "settings.settings": "Настройки",
  "settings.settingsPageTitle": "Настройки - {page}",
  "settings.slovak": "словацкий",
  "settings.smallDecimals": "Мелкие десятичные",
  "settings.smallDecimalsDescription": "Отображать десятичные цифры меньшим размером",
  "settings.spanish": "испанский",
  "settings.statusBarWidget": "Виджет строки состояния",
  "settings.statusBarWidgetDescription": "Всегда видимые данные о погоде",
  "settings.subscriptionSection": "Подписка",
  "settings.supportSection": "Поддержка",
  "settings.swedish": "шведский",
  "settings.systemTheme": "Системная тема",
  "settings.termsOfService": "Условия использования",
  "settings.themeDarkShort": "Темная",
  "settings.themeLightShort": "Светлая",
  "settings.themeSystemShort": "Системная",
  "settings.turkish": "турецкий",
  "settings.ukrainian": "украинский",
  "settings.units": "Единицы",
  "settings.unitsDescription": "Единицы измерения, отображаемые в приложении",
  "settings.update": "Обновить",
  "settings.windDirectionConvention": "Стрелка направления ветра",
  "settings.windDirectionConventionDescription": "Выберите отображение стрелок направления ветра",
  "settings.windDirectionMeteorological": "Направление источника",
  "settings.windDirectionMeteorologicalDescription": "Стрелка указывает, откуда дует ветер (метеорологическая конвенция)",
  "settings.windDirectionOceanographic": "Направление потока",
  "settings.windDirectionOceanographicDescription": "Стрелка указывает, куда дует ветер (океанографическая конвенция)",
  "stations.addAStation": "Добавить станцию",
  "stations.addToFavorites": "Добавить в избранное",
  "stations.addYourOwnStation": "Добавьте свою станцию",
  "stations.allowPreciseLocation": "Разрешить точное местоположение",
  "stations.approximateLocationUnavailable": "Приблизительное местоположение недоступно. Нажмите, чтобы разрешить точное местоположение.",
  "stations.backToCurrentLocation": "Назад к текущему местоположению",
  "stations.backToPlace": "Назад: {place}",
  "stations.browserLocationUnavailable": "Не удалось определить ваше местоположение. Проверьте, разрешает ли браузер этому сайту его использовать, и повторите попытку.",
  "stations.calculatedFor": "Рассчитано на {time} · {model}",
  "stations.clearRecentLocations": "Очистить все",
  "stations.currentLocation": "Текущее местоположение",
  "stations.customizedStationName": "Индивидуальное название станции",
  "stations.editMyWeather": "Изменить «Моя погода»",
  "stations.favoriteLocations": "Избранное",
  "stations.filterStations": "Фильтровать станции",
  "stations.filterStationSourceDescription": "Выберите поставщиков станций, которых вы хотите отобразить на карте.",
  "stations.findingYourLocation": "Определение вашего местоположения…",
  "stations.hiddenFromMyWeather": "Скрыто: {name}",
  "stations.hiddenStations": "Скрытые станции",
  "stations.hiddenStationsDescription": "Вы можете снова показать станцию, нажав на значок глаза рядом с ней.",
  "stations.hideStationNamed": "Скрыть {station}",
  "stations.lastSeen": "последний раз {time}",
  "stations.loadingStation": "Загрузка станции…",
  "stations.location": "Расположение",
  "stations.locationAddedToFavorites": "Место добавлено в избранное",
  "stations.locationNotGranted": "Разрешение на местоположение не предоставляется. Пожалуйста, разрешите доступ к вашему местоположению в настройках устройства.",
  "stations.locationRemovedFromFavorites": "Место удалено из избранного",
  "stations.locations": "Локации",
  "stations.locationUnavailable": "Не удалось определить ваше местоположение. Проверьте настройки устройства.",
  "stations.maxFavoriteLocationsReached": "Можно добавить не более 5 любимых мест. Удалите одно, чтобы добавить другое.",
  "stations.modifyFavoriteStations": "Измените любимые станции",
  "stations.modifyFavoriteStationsDescription": "Вы можете переупорядочить свои любимые станции, перетаскивая их. Вы также можете удалить их из списка.",
  "stations.moreStationsFailed": "Не удалось загрузить следующие станции",
  "stations.myLocation": "Моё местоположение",
  "stations.myStations": "Мои станции",
  "stations.myWeather": "Моя погода",
  "stations.myWeatherIntroBody": "Ваши станции остаются вверху. Поиск теперь находит населённые пункты и станции.",
  "stations.myWeatherIntroOk": "ОК",
  "stations.myWeatherIntroTitle": "Станции и места в одном списке",
  "stations.myWeatherItemActions": "Действия: {name}",
  "stations.nearbyWeatherStations": "Близлежащие погодные станции",
  "stations.noLocationsFound": "Места не найдены",
  "stations.noLocationTitle": "Где вы хотите узнать погоду?",
  "stations.noLongerReported": "Больше нет в списке",
  "stations.noLongerReportedBy": "{provider}: нет в списке с {date}",
  "stations.noPlaceFound": "Место не найдено",
  "stations.noSearchResults": "Нет статей, соответствующих вашему запросу",
  "stations.noStationNamed": "Нет станции с названием «{query}»",
  "stations.noStationsFound": "Станции не найдены",
  "stations.noWeatherStationYet": "У вас еще нет метеостанции.",
  "stations.places": "Места",
  "stations.placeSearchFailed": "Не удалось загрузить места",
  "stations.recentLocations": "Недавние",
  "stations.removedFromMyWeather": "Удалено: {name}",
  "stations.removeFromFavorites": "Удалить из Избранного",
  "stations.removeFromMyWeatherFailed": "Не удалось удалить: {name}",
  "stations.removeStationNamed": "Удалить {station} из Избранного",
  "stations.reorderStationNamed": "Переместить {station}",
  "stations.searchForLocation": "Поиск местоположения",
  "stations.searchForWeatherStation": "Поиск метеостанции",
  "stations.searchPlaceOrStation": "Поиск места или станции",
  "stations.searchResultsFound": "{count, plural, one {Найден # результат} few {Найдено # результата} many {Найдено # результатов} other {Найдено # результата}}",
  "stations.searchSummary": "{places, plural, one {# место} few {# места} many {# мест} other {# места}}, {stations, plural, one {# станция} few {# станции} many {# станций} other {# станции}}",
  "stations.searchTryAgain": "Повторить",
  "stations.selectStationForComparison": "Выберите станцию для сравнения",
  "stations.showAllStations": "Показать все ({count})",
  "stations.shownInMyWeather": "Снова показано: {name}",
  "stations.stationAddedToFavorites": "Станция добавлена в избранное",
  "stations.stationInformation": "Информация о станции",
  "stations.stationName": "Название станции",
  "stations.stationObservationsDescription": "Отображение последних наблюдений с метеостанций",
  "stations.stationRemovedFromFavorites": "Станция удалена из избранного",
  "stations.stationSearchFailed": "Не удалось загрузить станции",
  "stations.stationsLoading": "Загрузка метеостанций",
  "stations.stationType": "Тип станции",
  "stations.statusOffline": "Не в сети",
  "stations.statusOnline": "В сети",
  "stations.statusStale": "Устаревший",
  "stations.undoRemove": "Отменить",
  "stations.unhideStationNamed": "Снова показать {station}",
  "stations.useMyLocation": "Использовать моё местоположение",
  "stations.weatherStation": "Метеостанция",
  "stations.weatherStations": "Метеостанции",
  "stations.welcomeConnectService": "Есть метеостанция? Подключите свой сервис",
  "stations.welcomeSubtitle": "Ваша погода — всё в одном месте",
  "thermostat.away": "Отсутствие",
  "thermostat.boilerOn": "Котел ВКЛ.",
  "thermostat.hg": "Защита от замерзания",
  "thermostat.homeInformation": "Информация о доме",
  "thermostat.homeName": "Название дома",
  "thermostat.manualBoost": "Ручной буст",
  "thermostat.manualSetpointUntil": "Ручная уставка до",
  "thermostat.noThermostatYet": "У вас еще нет термостата.",
  "thermostat.relay": "Реле",
  "thermostat.room": "Комната",
  "thermostat.roomAnticipating": "Заблаговременный нагрев до следующей запланированной температуры",
  "thermostat.roomOpenWindow": "Обнаружено открытое окно, отопление приостановлено",
  "thermostat.rooms": "Комнаты",
  "thermostat.smartThermostat": "Умный термостат",
  "thermostat.smartValve": "Умный клапан",
  "thermostat.whenBackHome": "Когда вы вернётесь домой?",
  "units.celsius": "Цельсий",
  "units.fahrenheit": "Фаренгейт",
  "units.inch": "Дюймы",
  "units.inchOfMercury": "Дюймы ртутного столба",
  "units.kelvin": "Кельвин",
  "units.kilometerPerHour": "Километры в час",
  "units.knot": "Узлы",
  "units.meterPerSecond": "Метры в секунду",
  "units.milePerHour": "Мили в час",
  "units.millibar": "Миллибары",
  "units.millimeter": "Миллиметры",
  "units.millimeterOfMercury": "Миллиметры ртутного столба",
  "weatherConditions.blizzard": "Метель",
  "weatherConditions.blowingDust": "Пыльный позёмок",
  "weatherConditions.blowingSnow": "Позёмок",
  "weatherConditions.breezy": "Лёгкий ветер",
  "weatherConditions.clear": "Ясно",
  "weatherConditions.cloudy": "Пасмурно",
  "weatherConditions.drizzle": "Морось",
  "weatherConditions.flurries": "Слабый снег",
  "weatherConditions.foggy": "Туман",
  "weatherConditions.freezingDrizzle": "Переохлаждённая морось",
  "weatherConditions.freezingRain": "Ледяной дождь",
  "weatherConditions.frigid": "Сильный мороз",
  "weatherConditions.hail": "Град",
  "weatherConditions.haze": "Мгла",
  "weatherConditions.heavyRain": "Сильный дождь",
  "weatherConditions.heavySnow": "Сильный снегопад",
  "weatherConditions.hot": "Жара",
  "weatherConditions.hurricane": "Ураган",
  "weatherConditions.isolatedThunderstorms": "Отдельные грозы",
  "weatherConditions.mixedRainAndHail": "Дождь с градом",
  "weatherConditions.mostlyClear": "Преимущественно ясно",
  "weatherConditions.mostlyCloudy": "Преимущественно пасмурно",
  "weatherConditions.mostlySunny": "Преимущественно солнечно",
  "weatherConditions.notAvailable": "Погодные условия недоступны",
  "weatherConditions.partlyCloudy": "Переменная облачность",
  "weatherConditions.rain": "Дождь",
  "weatherConditions.rainSleet": "Дождь с ледяной крупой",
  "weatherConditions.rainSnow": "Дождь со снегом",
  "weatherConditions.scatteredShowers": "Местами ливни",
  "weatherConditions.scatteredSnowShowers": "Местами снежные заряды",
  "weatherConditions.scatteredThunderstorms": "Местами грозы",
  "weatherConditions.showers": "Ливни",
  "weatherConditions.sleet": "Ледяная крупа",
  "weatherConditions.smoke": "Дым",
  "weatherConditions.snow": "Снег",
  "weatherConditions.snowShowers": "Снежные заряды",
  "weatherConditions.strongStorms": "Сильные грозы",
  "weatherConditions.sunny": "Солнечно",
  "weatherConditions.thunderstorms": "Грозы",
  "weatherConditions.tornado": "Торнадо",
  "weatherConditions.tropicalStorm": "Тропический шторм",
  "weatherConditions.windy": "Ветрено",
  "weatherConditions.wintryMix": "Смешанные зимние осадки",
  "weatherMap.clusterMarkerName": "{metric} {value}, медиана по {count, plural, one {# станции} few {# станциям} many {# станциям} other {# станции}}, приблизить",
  "weatherMap.legendHeavy": "Сильный",
  "weatherMap.legendLight": "Слабый",
  "weatherMap.legendLightningHelp": "Цвет показывает возраст каждой молнии за последние {minutes} минут — самые новые белым, самые старые тёмно-красным.",
  "weatherMap.legendNewest": "Самые новые",
  "weatherMap.legendOldest": "Самые старые",
  "weatherMap.legendStationsHelp": "Цвет маркера отражает значение выбранного показателя.",
  "weatherMap.lightningDataAttribution": "Данные о молниях: Blitzortung.org",
  "weatherMap.lightningStrikes": "Удары молний",
  "weatherMap.lightningStrikesDescription": "Показывать удары молний на карте в реальном времени",
  "weatherMap.mapLayers": "Слои карты",
  "weatherMap.mapLegend": "Легенда карты",
  "weatherMap.mapMode": "Режим карты",
  "weatherMap.mapNameForecast": "Прогнозная карта, {model}, {variable}",
  "weatherMap.mapNameObservations": "Карта погоды, наблюдения",
  "weatherMap.modeForecast": "Прогноз",
  "weatherMap.modeObservations": "Наблюдения",
  "weatherMap.radarCardLabel": "Дождевой радар в {time}",
  "weatherMap.radarDataAttribution": "Данные радара: NOAA / EUMETNET OPERA / Radar-DPC via LibreWXR",
  "weatherMap.radarLoading": "Загрузка дождевого радара",
  "weatherMap.radarTime": "Время радарного снимка",
  "weatherMap.radarUnavailable": "Радар недоступен",
  "weatherMap.rainRadar": "Дождевой радар",
  "weatherMap.rainRadarDescription": "Отображение наложения радара дождя на карте",
  "weatherMap.resetBearing": "Перетащите, чтобы повернуть карту; нажмите, чтобы сориентировать её на север",
  "weatherMap.showingForecast": "Показан прогноз: {model}, {variable}",
  "weatherMap.stationMarkerName": "{metric} {value}, одна станция",
  "weatherMap.stationMarkersHint": "Клавиши со стрелками переключают между станциями",
  "weatherMap.stationMarkerWindValue": "{speed}, направление {direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain — это дополнительный источник данных, предоставляемый через систему погоды Tempest на базе технологии Nearcast. Данные NC Rain — это оценка среднего накопления осадков вокруг вашего Tempest на уровне района.",
  "weatherMap.weatherMap": "Карта погоды",
  "weatherMap.weatherMapMetaDescription": "SmartMixin предлагает интерактивные карты погоды и радара для метеорологических условий по всему миру.",
  "weatherMap.zoomIn": "Приблизить",
  "weatherMap.zoomOut": "Отдалить",
  "weatherWarnings.activeNow": "Действуют сейчас",
  "weatherWarnings.agencyMessage": "Сообщение метеослужбы",
  "weatherWarnings.areaCovered": "Затронутая территория",
  "weatherWarnings.areaThisLocation": "{area} (это место)",
  "weatherWarnings.areaYourStation": "{area} (ваша метеостанция)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Официальное предупреждение, {severity}: {hazard}} one {Официальное предупреждение, {severity}: {hazard}, и ещё #} few {Официальное предупреждение, {severity}: {hazard}, и ещё #} many {Официальное предупреждение, {severity}: {hazard}, и ещё #} other {Официальное предупреждение, {severity}: {hazard}, и ещё #}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Предстоящее официальное предупреждение, {severity}: {hazard}} one {Предстоящее официальное предупреждение, {severity}: {hazard}, и ещё #} few {Предстоящее официальное предупреждение, {severity}: {hazard}, и ещё #} many {Предстоящее официальное предупреждение, {severity}: {hazard}, и ещё #} other {Предстоящее официальное предупреждение, {severity}: {hazard}, и ещё #}}",
  "weatherWarnings.crumb": "Официальные предупреждения",
  "weatherWarnings.emptyBody": "Национальная метеослужба не выпустила действующих предупреждений для этого места. Мы проверяем снова каждые несколько минут.",
  "weatherWarnings.emptyTitle": "Нет официальных предупреждений",
  "weatherWarnings.ended": "Завершено",
  "weatherWarnings.endedAt": "Это предупреждение завершилось {time}.",
  "weatherWarnings.errorBody": "Проверьте подключение. Мы повторяем попытку каждые несколько минут.",
  "weatherWarnings.errorTitle": "Не удалось загрузить официальные предупреждения",
  "weatherWarnings.fromTime": "С {time}",
  "weatherWarnings.hazardAirQuality": "Качество воздуха",
  "weatherWarnings.hazardAvalanche": "Лавины",
  "weatherWarnings.hazardCoastalEvent": "Прибрежные опасности",
  "weatherWarnings.hazardFlood": "Наводнения",
  "weatherWarnings.hazardFog": "Туман",
  "weatherWarnings.hazardForestFire": "Лесные пожары",
  "weatherWarnings.hazardHighTemperature": "Высокие температуры",
  "weatherWarnings.hazardLowTemperature": "Низкие температуры",
  "weatherWarnings.hazardOther": "Другая опасность",
  "weatherWarnings.hazardRain": "Дождь",
  "weatherWarnings.hazardSnowIce": "Снег и гололёд",
  "weatherWarnings.hazardThunderstorm": "Грозы",
  "weatherWarnings.hazardUv": "УФ-излучение",
  "weatherWarnings.hazardWind": "Ветер",
  "weatherWarnings.hideHazards": "Скрыть явления",
  "weatherWarnings.issuedBy": "Выпущено: {sender}",
  "weatherWarnings.lastUpdate": "Последнее обновление: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Карта затронутого района: {area}.} other {Карта затронутых районов, всего #. Выделено: {area}.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Карта затронутого района.} other {Карта затронутых районов, всего #.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Карта недоступна. Район указан ниже.} other {Карта недоступна. Список районов (#) приведён ниже.}}",
  "weatherWarnings.moreHazards": "+ ещё {count}: {hazards}",
  "weatherWarnings.notInLanguage": "Недоступно на языке: {language}. Показано в том виде, в каком опубликовано метеослужбой.",
  "weatherWarnings.openOn": "Открыть на сайте {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ ещё # район} few {+ ещё # района} many {+ ещё # районов} other {+ ещё # района}}",
  "weatherWarnings.severityExtreme": "Экстремальный",
  "weatherWarnings.severityFrom": "{severity} с {time}",
  "weatherWarnings.severityMinor": "Низкий",
  "weatherWarnings.severityModerate": "Умеренный",
  "weatherWarnings.severityNow": "{severity} сейчас",
  "weatherWarnings.severitySevere": "Серьёзный",
  "weatherWarnings.severityUntil": "{severity} до {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Показать # район} few {Показать все # района} many {Показать все # районов} other {Показать все # района}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {Показать # район на карте} few {Показать все # района на карте} many {Показать все # районов на карте} other {Показать все # района на карте}}",
  "weatherWarnings.showHazards": "Показать явления",
  "weatherWarnings.showPeriods": "{count, plural, one {Показать # период} few {Показать все # периода} many {Показать все # периодов} other {Показать все # периода}}",
  "weatherWarnings.source": "Источник: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, затем {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# официальное погодное предупреждение} few {# официальных погодных предупреждения} many {# официальных погодных предупреждений} other {# официального погодного предупреждения}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Официальные погодные предупреждения",
  "weatherWarnings.todayAt": "сегодня в {time}",
  "weatherWarnings.tomorrow": "Завтра",
  "weatherWarnings.tomorrowAt": "завтра в {time}",
  "weatherWarnings.upcoming": "Ожидаются",
  "weatherWarnings.viewAll": "Все официальные предупреждения",
  "weatherWarnings.whatToDo": "Что делать"
}
